import React, { useState, useEffect } from 'react';
import logo1 from '../assets/img/logo.svg';
import axios from 'axios';
import link from '../link';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import { components } from 'react-select';
import Table from './Table';
import BmiTable from './BmiTable';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// single option component
const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

// color code for pie charts and bar graph
const Optimal = '#81B35C';
const Good = '#53A6BA';
const Fair = '#F2B93B';
const Poor = '#EE4B2B';
const Low = '#0d92d4';
const Pre_diabetic = '#F39C12';
const VeryLow = '#39AE97';
const High = '#E74C3C';

// const High1 = '#FF8357';
const High1 = 'rgba(255, 131, 87, 0.75)';
const Optimal1 = 'rgba(173, 201, 101, 0.75)';
// const Optimal1 = '#ADC965';
const Low1 = 'rgba(250, 193, 114, 0.75)';
// const Low1 = '#FAC172';
// const Fair1 = '#89D5C9';
const Fair1 = 'rgba(137, 213, 201, 0.75)';
const ExtremelyLow1 = 'rgba(226, 91, 69, 0.75)';
// const ExtremelyLow1 = '#E25B45';
const LineTextColor = '#000000';

const HighDiabeticColor = '#4f81bd';
const AnemicColor = '#c0504d';
const HighCholesterolColor = '#9bbb59';
const HighUricColor = '#8064a2';

const underweight = 'blue';
const normal = 'green';
const inc = '#EEC54F';
const high = 'Orange';
const veryhigh = 'Red';

const linestyle = {
  color: LineTextColor,
  fontSize: '14px',
};

const genderList = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
];

const ageList = [
  { label: 'Select All', value: 'All' },
  {
    label: '0-17',
    value: '0-17',
  },
  {
    label: '18-40',
    value: '18-40',
  },
  {
    label: '41-60',
    value: '41-60',
  },
  {
    label: 'Above 60',
    value: '61-120',
  },
];

function Dashboard() {
  const [data, setData] = useState([]);
  const [backData, setBackData] = useState([]);
  const [campName, setCampName] = useState('');
  const [fmcs, setFmcs] = useState([]);
  const [selectFmc, setSelectFmc] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [specialityList, setSpecialityList] = useState([]);
  const [speciality, setSpeciality] = useState({});
  const [showObesity, setShowObesity] = useState(false);
  const [showSickle, setShowSickle] = useState(false);

  // overall pie chart data and modal open and close
  const [optimalTotalHealthScore, setOptimalTotalHealthScore] = useState([]);
  const [goodTotalHealthScore, setGoodTotalHealthScore] = useState([]);
  const [averageTotalHealthScore, setAverageTotalHealthScore] = useState([]);
  const [poorTotalHealthScore, setPoorTotalHealthScore] = useState([]);
  const [totalScoreValue, setTotalScoreValue] = useState('');
  const [totalScoreDataModel, setTotalScoreDataModel] = useState(false);

  // overall percent state to show in dashboard
  const [totalHealthScorePercent, setTotalHealthScorePercent] = useState(0);
  // overall data to show in main pie chart and info button modal state
  const [totalHealthScoreData, setTotalHealthScoreData] = useState([]);
  const [totalScoreModal, setTotalScoreModal] = useState(false);

  // chart data for age group wise show data for male
  const [ageGroupMaleChart, setAgeGroupMaleChart] = useState([]);
  // chart data for age group wise show data for female
  const [ageGroupFemaleChart, setAgeGroupFemaleChart] = useState([]);

  // show patient details on click on bar chart for age group
  const [ageChartValue, setAgeChartValue] = useState('');
  const [ageChartDataModel, setAgeChartDataModel] = useState(false);
  const [ageChartData, setAgeChartData] = useState([]);

  // it is to show whick chart and score they have selected
  const [selectChartValue, setSelectChartValue] = useState('');
  const [selectChartParameter, setSelectChartParameter] = useState('');
  const [selectChartValue1, setSelectChartValue1] = useState('');
  const [selectChartParameter1, setSelectChartParameter1] = useState('');

  // store parameter data of Non-Invasive Test
  const [optimalHealthScore, setOptimalHealthScore] = useState([]);
  const [goodHealthScore, setGoodHealthScore] = useState([]);
  const [averageHealthScore, setAverageHealthScore] = useState([]);
  const [poorHealthScore, setPoorHealthScore] = useState([]);
  const [nonInvcCount, setNoninviceCount] = useState();

  // store parameter data of Blood Glucose Test
  const [normalBloodGlucose, setNormalBloodGlucose] = useState([]);
  const [lowBloodGlucose, setLowBloodGlucose] = useState([]);
  const [diabeticBloodGlucose, setDiabeticBloodGlucose] = useState([]);
  const [veryLowBloodGlucose, setVeryLowBloodGlucose] = useState([]);
  const [preDiabeticBloodGlucose, setPreDiabeticBloodGlucose] = useState([]);
  const [bloodglucoseCount, setBloodglucosecount] = useState();

  // store parameter data of Hemoglobin Test
  const [normalHemoglobin, setNormalHemoglobin] = useState([]);
  const [lowHemoglobin, setLowHemoglobin] = useState([]);
  const [highHemoglobin, setHighHemoglobin] = useState([]);
  const [hemoglobinCount, sethemoglobinCount] = useState();

  // store parameter data of Cholesterol Test
  const [normalCholesterol, setNormalCholesterol] = useState([]);
  const [lessCholesterol, setLessCholesterol] = useState([]);
  const [borderLineCholesterol, setBorderLineCholesterol] = useState([]);
  const [highCholesterol, setHighCholesterol] = useState([]);
  const [cholestrolcount, setCholestrolcount] = useState();

  // store parameter data of Uric Acid Test
  const [normalUricAcid, setNormalUricAcid] = useState([]);
  const [lowUricAcid, setLowUricAcid] = useState([]);
  const [highUricAcid, setHighUricAcid] = useState([]);
  const [uricCount, setUriccount] = useState();

  // store parameter data of BMI Test
  const [underWeightBmi, setUnderWeightBmi] = useState([]);
  const [normalBmi, setNormalBmi] = useState([]);
  const [increasedBmi, setIncreasedBmi] = useState([]);
  const [highBmi, setHighBmi] = useState([]);
  const [veryhighBmi, setVeryhighBmi] = useState([]);
  const [bmiCount, setBmicount] = useState();

  // store parameter data of sickle sol Test
  const [positiveSolibility, setPositiveSoibility] = useState([]);
  const [negativeSolibility, setNegativeSoibility] = useState([]);

  // store parameter data of sickle RDT Test
  const [hbAA, setHbAA] = useState([]);
  const [hbAS, setHbAS] = useState([]);
  const [hbSS, setHbSS] = useState([]);
  const [hbAC, setHbAC] = useState([]);
  const [hbSC, setHbSC] = useState([]);
  const [hbCC, setHbCC] = useState([]);

  // which filter was selected and store date to state
  const [doctor, setDoctor] = useState([]);
  const [gender, setGender] = useState([]);
  const [age, setAge] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // data to be showed in pie chart for all the five tests mentioned
  const [healthScoreData, setHealthScoreData] = useState([]);
  const [bloodGlucoseScoreData, setBloodGlucoseScoreData] = useState([]);
  const [hemoglobinScoreData, setHemoglobinScoreData] = useState([]);
  const [cholesterolScoreData, setCholesterolScoreData] = useState([]);
  const [uricAcidScoreData, setUricAcidScoreData] = useState([]);
  const [bmiScoreData, setBmiScoreData] = useState([]);
  const [sicklsolScoreData, setSicklesolScoreData] = useState([]);
  const [sicklRDTScoreData, setSickleRDTScoreData] = useState([]);
  const [sicklesolCount, setSicklesolCount] = useState();
  const [sicklerdtCount, setSicklerdtCount] = useState();

  // after pie chart filter for multiple parameters and show the patient details of filter in that data
  const [multiFilter, setMultiFilter] = useState([]);
  const [multiFilterData, setMultiFilterData] = useState([]);
  const [multiFilterShow, setMultiFilterShow] = useState(false);

  // Modal state for every test available details
  const [healthScoreModal, setHealthScoreModal] = useState(false);
  const [bloodGlucoseScoreModal, setBloodGlucoseScoreModal] = useState(false);
  const [hemoglobinScoreModal, setHemoglobinScoreModal] = useState(false);
  const [cholesterolScoreModal, setCholesterolScoreModal] = useState(false);
  const [uricAcidScoreModal, setUricAcidScoreModal] = useState(false);
  const [overallHealthScoreModal, setOverallHealthScoreModal] = useState(false);
  const [bmiScoreModal, setBmiScoreModal] = useState(false);
  const [sickleSolScoreModal, setSickleSolScoreModal] = useState(false);
  const [sickleRDTScoreModal, setSickleRDTScoreModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [showPatientDetail, setShowPatientDetail] = useState(false);
  const [showPatientDetail1, setShowPatientDetail1] = useState(false);
  const [patientName, setPatientName] = useState('');
  // const [patientId, setPatientId] = useState('');
  // const [patientGender, setPatientGender] = useState('');
  const [patientDetail, setPatientDetail] = useState([]);
  // healthscore graph
  const [patientChartData, setPatientChartData] = useState([]);
  const [patientXLabels, setPatientXLabels] = useState([]);
  const [selectLineMax, setSelectLineMax] = useState(0);
  const [selectLineBackGraph, setSelectLineBackGraph] = useState([]);
  // blood glucose graph
  const [bloodGlucosePatientChartData, setBloodGlucosePatientChartData] =
    useState([]);
  const [bloodGlucosePatientXLabels, setBloodGlucosePatientXLabels] = useState(
    []
  );
  const [bloodGlucoseSelectLineMax, setBloodGlucoseSelectLineMax] = useState(0);
  const [bloodGlucoseSelectLineBackGraph, setBloodGlucoseSelectLineBackGraph] =
    useState([]);
  // hemoglobin graph
  const [hemoglobinPatientChartData, setHemoglobinPatientChartData] = useState(
    []
  );
  const [hemoglobinPatientXLabels, setHemoglobinPatientXLabels] = useState([]);
  const [hemoglobinSelectLineMax, setHemoglobinSelectLineMax] = useState(0);
  const [hemoglobinSelectLineBackGraph, setHemoglobinSelectLineBackGraph] =
    useState([]);
  // cholesterol graph
  const [cholesterolPatientChartData, setCholesterolPatientChartData] =
    useState([]);
  const [cholesterolPatientXLabels, setCholesterolPatientXLabels] = useState(
    []
  );
  const [cholesterolSelectLineMax, setCholesterolSelectLineMax] = useState(0);
  const [cholesterolSelectLineBackGraph, setCholesterolSelectLineBackGraph] =
    useState([]);
  // uricacid graph
  const [uricAcidPatientChartData, setUricAcidPatientChartData] = useState([]);
  const [uricAcidPatientXLabels, setUricAcidPatientXLabels] = useState([]);
  const [uricAcidSelectLineMax, setUricAcidSelectLineMax] = useState(0);
  const [uricAcidSelectLineBackGraph, setUricAcidSelectLineBackGraph] =
    useState([]);
  // bmi graph
  const [bmiPatientChartData, setBmiPatientChartData] = useState([]);
  const [bmiPatientXLabels, setBmiPatientXLabels] = useState([]);
  const [bmiSelectLineMax, setBmiSelectLineMax] = useState(0);
  const [bmiSelectLineBackGraph, setBmiSelectLineBackGraph] = useState([]);

  const [chartLoading, setChartLoading] = useState(false);
  const [logo, setLogo] = useState(null);
  const [loaderText, setLoaderText] = useState('Loading ...');
  const navigate = useNavigate();

  const generateChartData = (testData) => {
    // OverAll Pie Chart Data filter to respective parameters
    let optimaltotalhealthscore = testData.filter(
      (d) => d.Total_SCORE > 9.9 && d.Total_SCORE !== null
    );
    let goodtotalhealthscore = testData.filter(
      (d) =>
        d.Total_SCORE <= 9.9 && d.Total_SCORE >= 8 && d.Total_SCORE !== null
    );
    let averagetotalhealthscore = testData.filter(
      (d) =>
        d.Total_SCORE >= 4 && d.Total_SCORE <= 7.99 && d.Total_SCORE !== null
    );
    let poortotalhealthscore = testData.filter(
      (d) => d.Total_SCORE <= 3.99 && d.Total_SCORE !== null
    );
    let totaldatatotalhealthscore = testData.filter(
      (d) => d.Total_SCORE !== null
    );
    let yOptimalTotalHealthScore = Math.round(
      (optimaltotalhealthscore.length / totaldatatotalhealthscore.length) * 100
    );
    let yGoodTotalHealthScore = Math.round(
      (goodtotalhealthscore.length / totaldatatotalhealthscore.length) * 100
    );
    let yFairTotalHealthScore = Math.round(
      (averagetotalhealthscore.length / totaldatatotalhealthscore.length) * 100
    );
    let yPoorTotalHealthScore = Math.round(
      (poortotalhealthscore.length / totaldatatotalhealthscore.length) * 100
    );
    // console.log(optimaltotalhealthscore.length, goodtotalhealthscore.length, averagetotalhealthscore.length, poortotalhealthscore.length, totaldatatotalhealthscore.length);
    setTotalHealthScoreData([
      {
        name: 'Optimal',
        color: Optimal,
        y: yOptimalTotalHealthScore,
        // z: 60,
      },
      {
        name: 'Good',
        color: Good,
        y: yGoodTotalHealthScore,
        // z: 40,
      },
      {
        name: 'Fair',
        color: Fair,
        y: yFairTotalHealthScore,
        // z: 30
      },
      {
        name: 'Poor',
        color: Poor,
        y: yPoorTotalHealthScore,
        // z: 20
      },
    ]);
    setOptimalTotalHealthScore(optimaltotalhealthscore);
    setGoodTotalHealthScore(goodtotalhealthscore);
    setAverageTotalHealthScore(averagetotalhealthscore);
    setPoorTotalHealthScore(poortotalhealthscore);

    // Non Invasive Pie Chart Data filter to respective parameters
    let optimalhealthscore = testData.filter(
      (d) => d.HealthScore_SCORE > 9.9 && d.HealthScore_SCORE !== null
    );
    let goodhealthscore = testData.filter(
      (d) =>
        d.HealthScore_SCORE <= 9.9 &&
        d.HealthScore_SCORE >= 8 &&
        d.HealthScore_SCORE !== null
    );
    let averagehealthscore = testData.filter(
      (d) =>
        d.HealthScore_SCORE >= 4 &&
        d.HealthScore_SCORE <= 7.99 &&
        d.HealthScore_SCORE !== null
    );
    let poorhealthscore = testData.filter(
      (d) => d.HealthScore_SCORE <= 3.99 && d.HealthScore_SCORE !== null
    );
    let totaldatahealthscore = testData.filter(
      (d) => d.HealthScore_SCORE !== null
    );
    setNoninviceCount(totaldatahealthscore.length);
    setHealthScoreData([
      {
        name: 'Optimal',
        color: Optimal,
        y: Math.round(
          (optimalhealthscore.length / totaldatahealthscore.length) * 100
        ),
      },
      {
        name: 'Good',
        color: Good,
        y: Math.round(
          (goodhealthscore.length / totaldatahealthscore.length) * 100
        ),
      },
      {
        name: 'Fair',
        color: Fair,
        y: Math.round(
          (averagehealthscore.length / totaldatahealthscore.length) * 100
        ),
      },
      {
        name: 'Poor',
        color: Poor,
        y: Math.round(
          (poorhealthscore.length / totaldatahealthscore.length) * 100
        ),
      },
    ]);
    setOptimalHealthScore(optimalhealthscore);
    setGoodHealthScore(goodhealthscore);
    setAverageHealthScore(averagehealthscore);
    setPoorHealthScore(poorhealthscore);

    // Blood Glucose Pie Chart Data filter to respective parameters
    let normalbloodglucose = testData.filter(
      (d) => d.BloodGlucose_SCORE === 10 && d.BloodGlucose_SCORE !== null
    );
    let lowbloodglucose = testData.filter(
      (d) => d.BloodGlucose_SCORE === 5 && d.BloodGlucose_SCORE !== null
    );
    let prediabeticbloodglucose = testData.filter(
      (d) => d.BloodGlucose_SCORE === 3 && d.BloodGlucose_SCORE !== null
    );
    let elowbloodglucose = testData.filter(
      (d) => d.BloodGlucose_SCORE === 1 && d.BloodGlucose_SCORE !== null
    );
    let diabeticbloodglucose = testData.filter(
      (d) => d.BloodGlucose_SCORE === 0 && d.BloodGlucose_SCORE !== null
    );
    let totaldatabloodglucose = testData.filter(
      (d) => d.BloodGlucose_SCORE !== null
    );
    setBloodglucosecount(totaldatabloodglucose.length);
    setBloodGlucoseScoreData([
      {
        name: 'Diabetic',
        color: High,
        y:
          (diabeticbloodglucose.length / totaldatabloodglucose.length) * 100 <
            1 &&
            (diabeticbloodglucose.length / totaldatabloodglucose.length) * 100 > 0
            ? 1
            : Math.round(
              (diabeticbloodglucose.length / totaldatabloodglucose.length) *
              100
            ),
      },
      {
        name: 'Pre-Diabetic',
        color: Pre_diabetic,
        y:
          (prediabeticbloodglucose.length / totaldatabloodglucose.length) *
            100 <
            1 &&
            (prediabeticbloodglucose.length / totaldatabloodglucose.length) *
            100 >
            0
            ? 1
            : Math.round(
              (prediabeticbloodglucose.length /
                totaldatabloodglucose.length) *
              100
            ),
      },
      {
        name: 'Normal',
        color: Optimal,
        y:
          (normalbloodglucose.length / totaldatabloodglucose.length) * 100 <
            1 &&
            (normalbloodglucose.length / totaldatabloodglucose.length) * 100 > 0
            ? 1
            : Math.round(
              (normalbloodglucose.length / totaldatabloodglucose.length) * 100
            ),
      },
      {
        name: 'Low',
        color: Low,
        y:
          (lowbloodglucose.length / totaldatabloodglucose.length) * 100 < 1 &&
            (lowbloodglucose.length / totaldatabloodglucose.length) * 100 > 0
            ? 1
            : Math.round(
              (lowbloodglucose.length / totaldatabloodglucose.length) * 100
            ),
      },
      {
        name: 'Very Low',
        color: VeryLow,
        y:
          (elowbloodglucose.length / totaldatabloodglucose.length) * 100 < 1 &&
            (elowbloodglucose.length / totaldatabloodglucose.length) * 100 > 0
            ? 1
            : Math.round(
              (elowbloodglucose.length / totaldatabloodglucose.length) * 100
            ),
      },
    ]);
    setDiabeticBloodGlucose(diabeticbloodglucose);
    setPreDiabeticBloodGlucose(prediabeticbloodglucose);
    setNormalBloodGlucose(normalbloodglucose);
    setLowBloodGlucose(lowbloodglucose);
    setVeryLowBloodGlucose(elowbloodglucose);
    // console.log(normalbloodglucose.length, lowbloodglucose.length, diabeticbloodglucose.length, prediabeticbloodglucose.length, elowbloodglucose.length, totaldatabloodglucose.length);

    // Hemoglobin Pie Chart Data filter to respective parameters
    let normalhemoglobin = testData.filter(
      (d) => d.HEMOGLOBIN_SCORE === 10 && d.HEMOGLOBIN_SCORE !== null
    );
    // let lowhemoglobin = testData.filter((d) => d.HEMOGLOBIN_SCORE === 5 && d.HEMOGLOBIN_SCORE !== null);
    let lowhemoglobin1 = testData.filter(
      (d) => d.HEMOGLOBIN_SCORE === 1 && d.HEMOGLOBIN_SCORE !== null
    );
    let lowhemoglobin2 = testData.filter(
      (d) => d.HEMOGLOBIN_SCORE === 5 && d.HEMOGLOBIN_SCORE !== null
    );
    let lowhemoglobin = [...lowhemoglobin1, ...lowhemoglobin2];
    let highhemoglobin = testData.filter(
      (d) => d.HEMOGLOBIN_SCORE === 0 && d.HEMOGLOBIN_SCORE !== null
    );
    let totaldatahemoglobin = testData.filter(
      (d) => d.HEMOGLOBIN_SCORE !== null
    );
    sethemoglobinCount(totaldatahemoglobin.length);
    setHemoglobinScoreData([
      {
        name: 'Low',
        color: Low,
        y:
          (lowhemoglobin.length / totaldatahemoglobin.length) * 100 < 1 &&
            (lowhemoglobin.length / totaldatahemoglobin.length) * 100 > 0
            ? 1
            : Math.round(
              (lowhemoglobin.length / totaldatahemoglobin.length) * 100
            ),
      },
      {
        name: 'Normal',
        color: Optimal,
        y:
          (normalhemoglobin.length / totaldatahemoglobin.length) * 100 < 1 &&
            (normalhemoglobin.length / totaldatahemoglobin.length) * 100 > 0
            ? 1
            : Math.round(
              (normalhemoglobin.length / totaldatahemoglobin.length) * 100
            ),
      },
      {
        name: 'High',
        color: High,
        y:
          (highhemoglobin.length / totaldatahemoglobin.length) * 100 < 1 &&
            (highhemoglobin.length / totaldatahemoglobin.length) * 100 > 0
            ? 1
            : Math.round(
              (highhemoglobin.length / totaldatahemoglobin.length) * 100
            ),
      },
    ]);
    setLowHemoglobin(lowhemoglobin);
    setNormalHemoglobin(normalhemoglobin);
    setHighHemoglobin(highhemoglobin);
    // console.log(normalhemoglobin.length, highhemoglobin.length, lowhemoglobin.length, totaldatahemoglobin.length);

    // Cholesterol Pie Chart Data filter to respective parameters
    let normalcholesterol = testData.filter(
      (d) => d.Cholestrol_SCORE === 10 && d.Cholestrol_SCORE !== null
    );
    let highcholesterol = testData.filter(
      (d) => d.Cholestrol_SCORE === 0 && d.Cholestrol_SCORE !== null
    );
    let lesscholesterol = testData.filter(
      (d) => d.Cholestrol_SCORE === 1 && d.Cholestrol_SCORE !== null
    );
    let borderlinecholesterol = testData.filter(
      (d) => d.Cholestrol_SCORE === 5 && d.Cholestrol_SCORE !== null
    );
    let totaldatacholesterol = testData.filter(
      (d) => d.Cholestrol_SCORE !== null
    );
    setCholestrolcount(totaldatacholesterol.length);
    setCholesterolScoreData([
      {
        name: 'High',
        color: High,
        y:
          (highcholesterol.length / totaldatacholesterol.length) * 100 < 1 &&
            (highcholesterol.length / totaldatacholesterol.length) * 100 > 0
            ? 1
            : Math.round(
              (highcholesterol.length / totaldatacholesterol.length) * 100
            ),
      },
      {
        name: 'Border Line',
        color: Low,
        y:
          (borderlinecholesterol.length / totaldatacholesterol.length) * 100 <
            1 &&
            (borderlinecholesterol.length / totaldatacholesterol.length) * 100 > 0
            ? 1
            : Math.round(
              (borderlinecholesterol.length / totaldatacholesterol.length) *
              100
            ),
      },
      {
        name: 'Normal',
        color: Optimal,
        y:
          (normalcholesterol.length / totaldatacholesterol.length) * 100 < 1 &&
            (normalcholesterol.length / totaldatacholesterol.length) * 100 > 0
            ? 1
            : Math.round(
              (normalcholesterol.length / totaldatacholesterol.length) * 100
            ),
      },
      {
        name: 'Less',
        color: Pre_diabetic,
        y:
          (lesscholesterol.length / totaldatacholesterol.length) * 100 < 1 &&
            (lesscholesterol.length / totaldatacholesterol.length) * 100 > 0
            ? 1
            : Math.round(
              (lesscholesterol.length / totaldatacholesterol.length) * 100
            ),
      },
    ]);
    setHighCholesterol(highcholesterol);
    setBorderLineCholesterol(borderlinecholesterol);
    setNormalCholesterol(normalcholesterol);
    setLessCholesterol(lesscholesterol);
    // console.log(normalcholesterol.length, borderlinecholesterol.length, lesscholesterol.length, highcholesterol.length, totaldatacholesterol.length);

    // Uric Acid Pie Chart Data filter to respective parameters
    let normaluricacid = testData.filter(
      (d) => d.UricAcid_SCORE === 10 && d.UricAcid_SCORE !== null
    );
    let highuricacid = testData.filter(
      (d) => d.UricAcid_SCORE === 0 && d.UricAcid_SCORE !== null
    );
    let lowuricacid = testData.filter(
      (d) => d.UricAcid_SCORE === 1 && d.UricAcid_SCORE !== null
    );
    let totaldatauricacid = testData.filter((d) => d.UricAcid_SCORE !== null);
    setUriccount(totaldatauricacid.length);
    setUricAcidScoreData([
      {
        name: 'High',
        color: High,
        y:
          (highuricacid.length / totaldatauricacid.length) * 100 < 1 &&
            (highuricacid.length / totaldatauricacid.length) * 100 > 0
            ? 1
            : Math.round(
              (highuricacid.length / totaldatauricacid.length) * 100
            ),
      },
      {
        name: 'Normal',
        color: Optimal,
        y:
          (normaluricacid.length / totaldatauricacid.length) * 100 < 1 &&
            (normaluricacid.length / totaldatauricacid.length) * 100 > 0
            ? 1
            : Math.round(
              (normaluricacid.length / totaldatauricacid.length) * 100
            ),
      },
      {
        name: 'Low',
        color: Low,
        y:
          (lowuricacid.length / totaldatauricacid.length) * 100 < 1 &&
            (lowuricacid.length / totaldatauricacid.length) * 100 > 0
            ? 1
            : Math.round((lowuricacid.length / totaldatauricacid.length) * 100),
      },
    ]);
    setHighUricAcid(highuricacid);
    setNormalUricAcid(normaluricacid);
    setLowUricAcid(lowuricacid);

    // BMI Pie Chart Data filter to respective parameters
    let underweightbmi = testData.filter(
      (d) => d.BMI_SCORE === 1 && d.BMI_SCORE !== null
    );
    let normalbmi = testData.filter(
      (d) => d.BMI_SCORE === 10 && d.BMI_SCORE !== null
    );
    let increasedbmi = testData.filter(
      (d) => d.BMI_SCORE === 5 && d.BMI_SCORE !== null
    );
    let highbmi = testData.filter(
      (d) => d.BMI_SCORE === 2 && d.BMI_SCORE !== null
    );
    let veryhighbmi = testData.filter(
      (d) => d.BMI_SCORE === 0 && d.BMI_SCORE !== null
    );
    let totalbmi = testData.filter((d) => d.BMI_SCORE !== null);
    // console.log(underweightbmi)
    setBmicount(totalbmi.length);
    setBmiScoreData([
      {
        name: 'Underweight',
        color: underweight,
        y:
          (underweightbmi.length / totalbmi.length) * 100 < 1 &&
            (underweightbmi.length / totalbmi.length) * 100 > 0
            ? 1
            : Math.round((underweightbmi.length / totalbmi.length) * 100),
      },
      {
        name: 'Normal',
        color: Optimal,
        y:
          (normalbmi.length / totalbmi.length) * 100 < 1 &&
            (normalbmi.length / totalbmi.length) * 100 > 0
            ? 1
            : Math.round((normalbmi.length / totalbmi.length) * 100),
      },
      {
        name: 'Increased',
        color: inc,
        y:
          (increasedbmi.length / totalbmi.length) * 100 < 1 &&
            (increasedbmi.length / totalbmi.length) * 100 > 0
            ? 1
            : Math.round((increasedbmi.length / totalbmi.length) * 100),
      },
      {
        name: 'High',
        color: high,
        y:
          (highbmi.length / totalbmi.length) * 100 < 1 &&
            (highbmi.length / totalbmi.length) * 100 > 0
            ? 1
            : Math.round((highbmi.length / totalbmi.length) * 100),
      },
      {
        name: 'Very High',
        color: veryhigh,
        y:
          (veryhighbmi.length / totalbmi.length) * 100 < 1 &&
            (veryhighbmi.length / totalbmi.length) * 100 > 0
            ? 1
            : Math.round((veryhighbmi.length / totalbmi.length) * 100),
      },
    ]);
    setUnderWeightBmi(underweightbmi);
    setNormalBmi(normalbmi);
    setIncreasedBmi(increasedbmi);
    setHighBmi(highbmi);
    setVeryhighBmi(veryhighbmi);

    // sickleSolubility Pie Chart Data filter to respective parameters
    let positiveSol = testData.filter(
      (d) => d.SickleCell_SOL === 'Positive' && d.SickleCell_SOL !== null
    );
    let negativeSol = testData.filter(
      (d) => d.SickleCell_SOL === 'Negative' && d.SickleCell_SOL !== null
    );
    let totalSol = testData.filter((d) => d.SickleCell_SOL !== null);
    //  console.log(underweightbmi)
    setSicklesolCount(totalSol.length);
    setSicklesolScoreData([
      {
        name: 'Positve',
        color: veryhigh,
        y:
          (positiveSol.length / totalSol.length) * 100 < 1 &&
            (positiveSol.length / totalSol.length) * 100 > 0
            ? 1
            : Math.round((positiveSol.length / totalSol.length) * 100),
      },
      {
        name: 'Negative',
        color: Optimal,
        y:
          (negativeSol.length / totalSol.length) * 100 < 1 &&
            (negativeSol.length / totalSol.length) * 100 > 0
            ? 1
            : Math.round((negativeSol.length / totalSol.length) * 100),
      },
    ]);
    setPositiveSoibility(positiveSol);
    setNegativeSoibility(negativeSol);

    // sickleSolubility Pie Chart Data filter to respective parameters
    let HbAA = testData.filter(
      (d) =>
        d.SickleCell_SCORE_TEXT === 'Sickle Cell Absent' &&
        d.SickleCell_SCORE_TEXT !== null
    );
    let HbAS = testData.filter(
      (d) =>
        d.SickleCell_SCORE_TEXT === 'HbAS Trait' &&
        d.SickleCell_SCORE_TEXT !== null
    );
    let HbSS = testData.filter(
      (d) =>
        d.SickleCell_SCORE_TEXT === 'Sickle Cell Anemia' &&
        d.SickleCell_SCORE_TEXT !== null
    );
    let HbAC = testData.filter(
      (d) =>
        d.SickleCell_SCORE_TEXT === 'HbAC Trait' &&
        d.SickleCell_SCORE_TEXT !== null
    );
    let HbSC = testData.filter(
      (d) =>
        d.SickleCell_SCORE_TEXT === 'HbSC Trait' &&
        d.SickleCell_SCORE_TEXT !== null
    );
    let HbCC = testData.filter(
      (d) =>
        d.SickleCell_SCORE_TEXT === 'HbCC Trait' &&
        d.SickleCell_SCORE_TEXT !== null
    );

    let totalRdt = testData.filter((d) => d.SickleCell_SCORE_TEXT !== null);
    //  console.log(totalRdt);
    setSicklerdtCount(totalRdt.length);
    setSickleRDTScoreData([
      {
        name: 'Absent',
        color: Optimal,
        y:
          (HbAA.length / totalRdt.length) * 100 < 1 &&
            (HbAA.length / totalRdt.length) * 100 > 0
            ? 1
            : Math.round((HbAA.length / totalRdt.length) * 100),
      },
      {
        name: 'HbAS Trait',
        color: high,
        y:
          (HbAS.length / totalRdt.length) * 100 < 1 &&
            (HbAS.length / totalRdt.length) * 100 > 0
            ? 1
            : Math.round((HbAS.length / totalRdt.length) * 100),
      },
      {
        name: 'Anemia',
        color: veryhigh,
        y:
          (HbSS.length / totalRdt.length) * 100 < 1 &&
            (HbSS.length / totalRdt.length) * 100 > 0
            ? 1
            : Math.round((HbSS.length / totalRdt.length) * 100),
      },
      {
        name: 'HbAC Trait',
        color: '#F453D9',
        y:
          (HbAC.length / totalRdt.length) * 100 < 1 &&
            (HbAC.length / totalRdt.length) * 100 > 0
            ? 1
            : Math.round((HbAC.length / totalRdt.length) * 100),
      },
      {
        name: 'HbSC Trait',
        color: VeryLow,
        y:
          (HbSC.length / totalRdt.length) * 100 < 1 &&
            (HbSC.length / totalRdt.length) * 100 > 0
            ? 1
            : Math.round((HbSC.length / totalRdt.length) * 100),
      },
      {
        name: 'HbCC Trait',
        color: '#0F27F2',
        y:
          (HbCC.length / totalRdt.length) * 100 < 1 &&
            (HbCC.length / totalRdt.length) * 100 > 0
            ? 1
            : Math.round((HbCC.length / totalRdt.length) * 100),
      },
    ]);
    setHbAA(HbAA);
    setHbAC(HbAC);
    setHbAS(HbAS);
    setHbSS(HbSS);
    setHbSC(HbSC);
    setHbCC(HbCC);

    // Bar Graph Age wise chart filter the data and seprate high parameters and show in percent
    const lessthaneighteendiabetic = diabeticbloodglucose.filter(
      (d) => d.age <= 17
    );
    const lessthaneighteenanemic = lowhemoglobin.filter((d) => d.age <= 17);
    const lessthaneighteenhighcholesterol = highcholesterol.filter(
      (d) => d.age <= 17
    );
    const lessthaneighteenuricacid = highuricacid.filter((d) => d.age <= 17);
    const morethaneighteenlessthanfortyonediabetic =
      diabeticbloodglucose.filter((d) => d.age >= 18 && d.age <= 40);
    const morethaneighteenlessthanfortyoneanemic = lowhemoglobin.filter(
      (d) => d.age >= 18 && d.age <= 40
    );
    const morethaneighteenlessthanfortyonehighcholesterol =
      highcholesterol.filter((d) => d.age >= 18 && d.age <= 40);
    const morethaneighteenlessthanfortyoneuricacid = highuricacid.filter(
      (d) => d.age >= 18 && d.age <= 40
    );
    const morethanfortyonelessthansixtyonediabetic =
      diabeticbloodglucose.filter((d) => d.age >= 41 && d.age <= 60);
    const morethanfortyonelessthansixtyoneanemic = lowhemoglobin.filter(
      (d) => d.age >= 41 && d.age <= 60
    );
    const morethanfortyonelessthansixtyonehighcholesterol =
      highcholesterol.filter((d) => d.age >= 41 && d.age <= 60);
    const morethanfortyonelessthansixtyoneuricacid = highuricacid.filter(
      (d) => d.age >= 41 && d.age <= 60
    );
    const greaterthansixtydiabetic = diabeticbloodglucose.filter(
      (d) => d.age > 60
    );
    const greaterthansixtyanemic = lowhemoglobin.filter((d) => d.age > 60);
    const greaterthansixtyhighcholesterol = highcholesterol.filter(
      (d) => d.age > 60
    );
    const greaterthansixtyuricacid = highuricacid.filter((d) => d.age > 60);
    setAgeGroupMaleChart([
      {
        name: 'Diabetic',
        color: HighDiabeticColor,
        data: [
          lessthaneighteendiabetic.length > 0
            ? Math.round(
              (lessthaneighteendiabetic.filter((d) => d.Gender === 'Male')
                .length /
                totaldatabloodglucose.filter(
                  (d) => d.age <= 17 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
          morethaneighteenlessthanfortyonediabetic.length > 0
            ? Math.round(
              (morethaneighteenlessthanfortyonediabetic.filter(
                (d) => d.Gender === 'Male'
              ).length /
                totaldatabloodglucose.filter(
                  (d) => d.age >= 18 && d.age <= 40 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
          morethanfortyonelessthansixtyonediabetic.length > 0
            ? Math.round(
              (morethanfortyonelessthansixtyonediabetic.filter(
                (d) => d.Gender === 'Male'
              ).length /
                totaldatabloodglucose.filter(
                  (d) => d.age >= 41 && d.age <= 60 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
          greaterthansixtydiabetic.length > 0
            ? Math.round(
              (greaterthansixtydiabetic.filter((d) => d.Gender === 'Male')
                .length /
                totaldatabloodglucose.filter(
                  (d) => d.age > 60 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
        ],
      },
      {
        name: 'Anaemic',
        color: AnemicColor,
        data: [
          lessthaneighteenanemic.length > 0
            ? Math.round(
              (lessthaneighteenanemic.filter((d) => d.Gender === 'Male')
                .length /
                totaldatahemoglobin.filter(
                  (d) => d.age <= 17 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
          morethaneighteenlessthanfortyoneanemic.length > 0
            ? Math.round(
              (morethaneighteenlessthanfortyoneanemic.filter(
                (d) => d.Gender === 'Male'
              ).length /
                totaldatahemoglobin.filter(
                  (d) => d.age >= 18 && d.age <= 40 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
          morethanfortyonelessthansixtyoneanemic.length > 0
            ? Math.round(
              (morethanfortyonelessthansixtyoneanemic.filter(
                (d) => d.Gender === 'Male'
              ).length /
                totaldatahemoglobin.filter(
                  (d) => d.age >= 41 && d.age <= 60 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
          greaterthansixtyanemic.length > 0
            ? Math.round(
              (greaterthansixtyanemic.filter((d) => d.Gender === 'Male')
                .length /
                totaldatahemoglobin.filter(
                  (d) => d.age > 60 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
        ],
      },
      {
        name: 'High Cholesterol',
        color: HighCholesterolColor,
        data: [
          lessthaneighteenanemic.length > 0
            ? Math.round(
              (lessthaneighteenhighcholesterol.filter(
                (d) => d.Gender === 'Male'
              ).length /
                totaldatacholesterol.filter(
                  (d) => d.age <= 17 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
          morethaneighteenlessthanfortyonehighcholesterol.length > 0
            ? Math.round(
              (morethaneighteenlessthanfortyonehighcholesterol.filter(
                (d) => d.Gender === 'Male'
              ).length /
                totaldatacholesterol.filter(
                  (d) => d.age >= 18 && d.age <= 40 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
          morethanfortyonelessthansixtyonehighcholesterol.length > 0
            ? Math.round(
              (morethanfortyonelessthansixtyonehighcholesterol.filter(
                (d) => d.Gender === 'Male'
              ).length /
                totaldatacholesterol.filter(
                  (d) => d.age >= 41 && d.age <= 60 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
          greaterthansixtyhighcholesterol.length > 0
            ? Math.round(
              (greaterthansixtyhighcholesterol.filter(
                (d) => d.Gender === 'Male'
              ).length /
                totaldatacholesterol.filter(
                  (d) => d.age > 60 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
        ],
      },
      {
        name: 'High Uric Acid',
        color: HighUricColor,
        data: [
          lessthaneighteenuricacid.length > 0
            ? Math.round(
              (lessthaneighteenuricacid.filter((d) => d.Gender === 'Male')
                .length /
                totaldatauricacid.filter(
                  (d) => d.age <= 17 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
          morethaneighteenlessthanfortyoneuricacid.length > 0
            ? Math.round(
              (morethaneighteenlessthanfortyoneuricacid.filter(
                (d) => d.Gender === 'Male'
              ).length /
                totaldatauricacid.filter(
                  (d) => d.age >= 18 && d.age <= 40 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
          morethanfortyonelessthansixtyoneuricacid.length > 0
            ? Math.round(
              (morethanfortyonelessthansixtyoneuricacid.filter(
                (d) => d.Gender === 'Male'
              ).length /
                totaldatauricacid.filter(
                  (d) => d.age >= 41 && d.age <= 60 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
          greaterthansixtyuricacid.length > 0
            ? Math.round(
              (greaterthansixtyuricacid.filter((d) => d.Gender === 'Male')
                .length /
                totaldatauricacid.filter(
                  (d) => d.age > 60 && d.Gender === 'Male'
                ).length) *
              100
            )
            : 0,
        ],
      },
    ]);
    setAgeGroupFemaleChart([
      {
        name: 'Diabetic',
        color: HighDiabeticColor,
        data: [
          lessthaneighteendiabetic.length > 0
            ? Math.round(
              (lessthaneighteendiabetic.filter((d) => d.Gender === 'Female')
                .length /
                totaldatabloodglucose.filter(
                  (d) => d.age <= 17 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
          morethaneighteenlessthanfortyonediabetic.length > 0
            ? Math.round(
              (morethaneighteenlessthanfortyonediabetic.filter(
                (d) => d.Gender === 'Female'
              ).length /
                totaldatabloodglucose.filter(
                  (d) => d.age >= 18 && d.age <= 40 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
          morethanfortyonelessthansixtyonediabetic.length > 0
            ? Math.round(
              (morethanfortyonelessthansixtyonediabetic.filter(
                (d) => d.Gender === 'Female'
              ).length /
                totaldatabloodglucose.filter(
                  (d) => d.age >= 41 && d.age <= 60 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
          greaterthansixtydiabetic.length > 0
            ? Math.round(
              (greaterthansixtydiabetic.filter((d) => d.Gender === 'Female')
                .length /
                totaldatabloodglucose.filter(
                  (d) => d.age > 60 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
        ],
      },
      {
        name: 'Anaemic',
        color: AnemicColor,
        data: [
          lessthaneighteenanemic.length > 0
            ? Math.round(
              (lessthaneighteenanemic.filter((d) => d.Gender === 'Female')
                .length /
                totaldatahemoglobin.filter(
                  (d) => d.age <= 17 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
          morethaneighteenlessthanfortyoneanemic.length > 0
            ? Math.round(
              (morethaneighteenlessthanfortyoneanemic.filter(
                (d) => d.Gender === 'Female'
              ).length /
                totaldatahemoglobin.filter(
                  (d) => d.age >= 18 && d.age <= 40 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
          morethanfortyonelessthansixtyoneanemic.length > 0
            ? Math.round(
              (morethanfortyonelessthansixtyoneanemic.filter(
                (d) => d.Gender === 'Female'
              ).length /
                totaldatahemoglobin.filter(
                  (d) => d.age >= 41 && d.age <= 60 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
          greaterthansixtyanemic.length > 0
            ? Math.round(
              (greaterthansixtyanemic.filter((d) => d.Gender === 'Female')
                .length /
                totaldatahemoglobin.filter(
                  (d) => d.age > 60 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
        ],
      },
      {
        name: 'High Cholesterol',
        color: HighCholesterolColor,
        data: [
          lessthaneighteenanemic.length > 0
            ? Math.round(
              (lessthaneighteenhighcholesterol.filter(
                (d) => d.Gender === 'Female'
              ).length /
                totaldatacholesterol.filter(
                  (d) => d.age <= 17 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
          morethaneighteenlessthanfortyonehighcholesterol.length > 0
            ? Math.round(
              (morethaneighteenlessthanfortyonehighcholesterol.filter(
                (d) => d.Gender === 'Female'
              ).length /
                totaldatacholesterol.filter(
                  (d) => d.age >= 18 && d.age <= 40 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
          morethanfortyonelessthansixtyonehighcholesterol.length > 0
            ? Math.round(
              (morethanfortyonelessthansixtyonehighcholesterol.filter(
                (d) => d.Gender === 'Female'
              ).length /
                totaldatacholesterol.filter(
                  (d) => d.age >= 41 && d.age <= 60 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
          greaterthansixtyhighcholesterol.length > 0
            ? Math.round(
              (greaterthansixtyhighcholesterol.filter(
                (d) => d.Gender === 'Female'
              ).length /
                totaldatacholesterol.filter(
                  (d) => d.age > 60 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
        ],
      },
      {
        name: 'High Uric Acid',
        color: HighUricColor,
        data: [
          lessthaneighteenuricacid.length > 0
            ? Math.round(
              (lessthaneighteenuricacid.filter((d) => d.Gender === 'Female')
                .length /
                totaldatauricacid.filter(
                  (d) => d.age <= 17 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
          morethaneighteenlessthanfortyoneuricacid.length > 0
            ? Math.round(
              (morethaneighteenlessthanfortyoneuricacid.filter(
                (d) => d.Gender === 'Female'
              ).length /
                totaldatauricacid.filter(
                  (d) => d.age >= 18 && d.age <= 40 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
          morethanfortyonelessthansixtyoneuricacid.length > 0
            ? Math.round(
              (morethanfortyonelessthansixtyoneuricacid.filter(
                (d) => d.Gender === 'Female'
              ).length /
                totaldatauricacid.filter(
                  (d) => d.age >= 41 && d.age <= 60 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
          greaterthansixtyuricacid.length > 0
            ? Math.round(
              (greaterthansixtyuricacid.filter((d) => d.Gender === 'Female')
                .length /
                totaldatauricacid.filter(
                  (d) => d.age > 60 && d.Gender === 'Female'
                ).length) *
              100
            )
            : 0,
        ],
      },
    ]);
    // calculating the overall health score percent
    let testsdone = 0;
    let sumScore = 0;
    for (let i = 0; i < testData.length; i++) {
      if (testData[i].Total_SCORE !== null) {
        sumScore = sumScore + Math.round(testData[i].Total_SCORE);
        testsdone += 1;
        // console.log(sumScore);
      }
    }
    let testtotal = testsdone * 10;
    // console.log(normaluricacid.length, lowuricacid.length, highuricacid.length, totaldatauricacid.length);
    // console.log(testtotal);
    // console.log(response.data.SumHealthScore);
    // console.log(Number(sumScore / testtotal * 100) === NaN ? true : false);
    setSelectChartValue('');
    setSelectChartParameter('');
    setSelectChartValue1('');
    setSelectChartParameter1('');
    setMultiFilterShow(false);
    setMultiFilter([]);
    setMultiFilterData([]);
    setTotalHealthScorePercent(Math.round((sumScore / testtotal) * 100));
  };

  useEffect(() => {
    setIsLoading(true);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const usertype = JSON.parse(sessionStorage.getItem('usertype'));
    const token = JSON.parse(sessionStorage.getItem('token'));
    setLogo(user?.avtar || null);
    // const token1 = JSON.parse(sessionStorage.getItem('token1'));
    // console.log(user, usertype)
    // check if the user is logged in or not and if not then logs then out to login page of admin or user depending on who is accesing the page
    if (token !== '' && usertype === 'admin') {
      // console.log(token, usertype);
      navigate('/admin');
    } else if (
      (token === undefined && usertype === 'user') ||
      (token === null && usertype === null)
    ) {
      navigate('/');
    }
    setLoaderText('Fetching data ...');
    // fetch data for the user logged in from api
    const fetchData = () => {
      axios
        .post(`${link.apiUrl1}/api/misdashboarddata/getHealthScore/data`, {
          fmc: user.fmcIds,
        })
        .then((response) => {
          // console.log(response.data);
          setLoaderText('Analyzing data ...');
          let filteredData = [];
          for (let i = 0; i < user.fmcIds.length; i++) {
            let clinicfilter = response.data.testData.filter(
              (d) => d.ClinicId === user.fmcIds[i].value
            );
            // console.log("loop", clinicfilter);
            if (clinicfilter.length !== 0) {
              filteredData.push(...clinicfilter);
            }
          }
          setData(filteredData);
          setCampName(user.organizationName);
          setBackData(filteredData);
          let result = response.data.doctorData.reduce((unique, o) => {
            if (!unique.some((obj) => obj._id === o._id)) {
              unique.push(o);
            }
            return unique;
          }, []);
          // console.log(result)
          setFmcs(
            user.fmcIds.sort((a, b) =>
              a.label.toLowerCase().localeCompare(b.label.toLowerCase())
            )
          );
          let dcdata = [];
          for (let i = 0; i < result.length; i++) {
            dcdata.push({
              label: `Dr. ${result[i].firstName} ${result[i].lastName}`,
              value: result[i]._id,
            });
          }
          setSelectFmc([]);
          setDoctor([]);
          setGender([]);
          setAge('');
          setChartLoading(false);
          setMultiFilter([]);
          setMultiFilterData([]);
          setMultiFilterShow(false);
          setStartDate(null);
          setEndDate(null);
          setTotalScoreDataModel(false);
          setHealthScoreModal(false);
          setBloodGlucoseScoreModal(false);
          //new
          setBmiScoreModal(false);
          setHemoglobinScoreModal(false);
          setUricAcidScoreModal(false);
          setOverallHealthScoreModal(false);
          setDoctorList(dcdata);
          setTotalScoreValue('');
          setSelectChartValue('');
          setSelectChartParameter('');
          setSelectChartValue1('');
          setSelectChartParameter1('');
          setTotalScoreDataModel(false);
          setShowPatientDetail(false);
          setShowPatientDetail1(false);
          setPatientChartData([]);
          setPatientDetail([]);
          setPatientXLabels([]);
          setSelectLineBackGraph([]);
          setSelectLineMax(0);
          setAgeChartValue('');
          setAgeChartData([]);
          setAgeChartDataModel(false);
          // setPatientGender('');
          setBloodGlucosePatientChartData([]);
          setBloodGlucosePatientXLabels([]);
          setBloodGlucoseSelectLineMax(0);
          setBloodGlucoseSelectLineBackGraph([]);
          setHemoglobinPatientChartData([]);
          setHemoglobinPatientXLabels([]);
          setHemoglobinSelectLineMax(0);
          setHemoglobinSelectLineBackGraph([]);
          setCholesterolPatientChartData([]);
          setCholesterolPatientXLabels([]);
          setCholesterolSelectLineMax(0);
          setCholesterolSelectLineBackGraph([]);
          setUricAcidPatientChartData([]);
          setUricAcidPatientXLabels([]);
          setUricAcidSelectLineMax(0);
          setUricAcidSelectLineBackGraph([]);
          generateChartData(filteredData);
          setTimeout(() => {
            setIsLoading(false);
            setLoaderText('Loading ...');
          }, 3000);
        });
    };
    const fetchSpeciality = () => {
      axios
        .get(`${link.apiUrl1}/api/speciality`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          // console.log(res)
          let spdata = [
            {
              label: 'All',
              value: 'All',
            },
          ];
          res.data.map((d) => {
            spdata.push({
              label: d.name,
              value: d.name,
            });
          });
          setSpecialityList(spdata);
        });
    };
    fetchData();
    fetchSpeciality();
  }, []);

  // useeffect to filter data whenever the user applies a filter from the dropdown
  useEffect(() => {
    let filteredData = [];
    // console.log(doctorList);
    if (
      selectFmc.length !== 0 &&
      doctor.length === 0 &&
      startDate === null &&
      endDate === null &&
      Object.keys(age).length === 0 &&
      Object.keys(gender).length === 0
    ) {
      const data = filterFmc(backData);
      filteredData.push(...data);
      // console.log(filteredData);
    } else if (
      selectFmc.length === 0 &&
      doctor.length === 0 &&
      startDate === null &&
      endDate === null &&
      Object.keys(age).length === 0 &&
      Object.keys(gender).length === 0
    ) {
      filteredData.push(...backData);
    } else if (
      selectFmc.length === 0 &&
      doctor.length !== 0 &&
      startDate === null &&
      endDate === null &&
      Object.keys(age).length === 0 &&
      Object.keys(gender).length === 0
    ) {
      const data = filterDoctor(backData);
      filteredData.push(...data);
    } else if (
      selectFmc.length === 0 &&
      doctor.length === 0 &&
      startDate === null &&
      endDate === null &&
      Object.keys(age).length !== 0 &&
      Object.keys(gender).length === 0
    ) {
      const data = filterAge(backData);
      filteredData.push(...data);
    } else if (
      selectFmc.length === 0 &&
      doctor.length === 0 &&
      startDate === null &&
      endDate === null &&
      Object.keys(age).length === 0 &&
      Object.keys(gender).length !== 0
    ) {
      // console.log(gender);
      const data = filterGender(backData);
      filteredData.push(...data);
    } else if (
      selectFmc.length === 0 &&
      doctor.length === 0 &&
      startDate !== null &&
      endDate !== null &&
      Object.keys(age).length === 0 &&
      Object.keys(gender).length === 0
    ) {
      // console.log(startDate, endDate);
      const data = filterDate(backData);
      filteredData.push(...data);
    } else if (
      (selectFmc.length !== 0 &&
        doctor.length !== 0 &&
        startDate === null &&
        endDate === null &&
        Object.keys(age).length === 0 &&
        Object.keys(gender).length === 0) ||
      (selectFmc.length !== 0 &&
        doctor.length === 0 &&
        startDate !== null &&
        endDate !== null &&
        Object.keys(age).length === 0 &&
        Object.keys(gender).length === 0) ||
      (selectFmc.length !== 0 &&
        doctor.length === 0 &&
        startDate === null &&
        endDate === null &&
        Object.keys(age).length !== 0 &&
        Object.keys(gender).length === 0) ||
      (selectFmc.length !== 0 &&
        doctor.length === 0 &&
        startDate === null &&
        endDate === null &&
        Object.keys(age).length === 0 &&
        Object.keys(gender).length !== 0)
    ) {
      let finalData = [];
      const data = filterFmc(backData);
      finalData.push(...data);
      if (doctor.length !== 0) {
        const data = filterDoctor(finalData);
        filteredData.push(...data);
      }
      if (startDate !== null && endDate !== null) {
        const data = filterDate(finalData);
        filteredData.push(...data);
      }
      if (Object.keys(age).length !== 0) {
        const data = filterAge(finalData);
        filteredData.push(...data);
      }
      if (Object.keys(gender).length !== 0) {
        const data = filterGender(finalData);
        filteredData.push(...data);
      }
    } else if (
      (selectFmc.length !== 0 &&
        doctor.length !== 0 &&
        startDate === null &&
        endDate === null &&
        Object.keys(age).length === 0 &&
        Object.keys(gender).length === 0) ||
      (selectFmc.length === 0 &&
        doctor.length !== 0 &&
        startDate !== null &&
        endDate !== null &&
        Object.keys(age).length === 0 &&
        Object.keys(gender).length === 0) ||
      (selectFmc.length === 0 &&
        doctor.length !== 0 &&
        startDate === null &&
        endDate === null &&
        Object.keys(age).length !== 0 &&
        Object.keys(gender).length === 0) ||
      (selectFmc.length === 0 &&
        doctor.length !== 0 &&
        startDate === null &&
        endDate === null &&
        Object.keys(age).length === 0 &&
        Object.keys(gender).length !== 0)
    ) {
      let finalData = [];
      const data = filterDoctor(backData);
      finalData.push(...data);
      if (selectFmc.length !== 0) {
        const data = filterFmc(finalData);
        filteredData.push(...data);
      }
      if (startDate !== null && endDate !== null) {
        const data = filterDate(finalData);
        filteredData.push(...data);
      }
      if (Object.keys(age).length !== 0) {
        const data = filterAge(finalData);
        filteredData.push(...data);
      }
      if (Object.keys(gender).length !== 0) {
        const data = filterGender(finalData);
        filteredData.push(...data);
      }
    } else if (
      (selectFmc.length !== 0 &&
        doctor.length === 0 &&
        startDate !== null &&
        endDate !== null &&
        Object.keys(age).length === 0 &&
        Object.keys(gender).length === 0) ||
      (selectFmc.length === 0 &&
        doctor.length !== 0 &&
        startDate !== null &&
        endDate !== null &&
        Object.keys(age).length === 0 &&
        Object.keys(gender).length === 0) ||
      (selectFmc.length === 0 &&
        doctor.length === 0 &&
        startDate !== null &&
        endDate !== null &&
        Object.keys(age).length !== 0 &&
        Object.keys(gender).length === 0) ||
      (selectFmc.length === 0 &&
        doctor.length === 0 &&
        startDate !== null &&
        endDate !== null &&
        Object.keys(age).length === 0 &&
        Object.keys(gender).length !== 0)
    ) {
      let finalData = [];
      const data = filterDate(backData);
      finalData.push(...data);
      if (doctor.length !== 0) {
        const data = filterDoctor(finalData);
        filteredData.push(...data);
      }
      if (selectFmc.length !== 0) {
        const data = filterFmc(finalData);
        filteredData.push(...data);
      }
      if (Object.keys(age).length !== 0) {
        const data = filterAge(finalData);
        filteredData.push(...data);
      }
      if (Object.keys(gender).length !== 0) {
        const data = filterGender(finalData);
        filteredData.push(...data);
      }
    } else if (
      (selectFmc.length !== 0 &&
        doctor.length === 0 &&
        startDate === null &&
        endDate === null &&
        Object.keys(age).length !== 0 &&
        Object.keys(gender).length === 0) ||
      (selectFmc.length === 0 &&
        doctor.length !== 0 &&
        startDate === null &&
        endDate === null &&
        Object.keys(age).length !== 0 &&
        Object.keys(gender).length === 0) ||
      (selectFmc.length === 0 &&
        doctor.length === 0 &&
        startDate !== null &&
        endDate !== null &&
        Object.keys(age).length !== 0 &&
        Object.keys(gender).length === 0) ||
      (selectFmc.length === 0 &&
        doctor.length === 0 &&
        startDate === null &&
        endDate === null &&
        Object.keys(age).length !== 0 &&
        Object.keys(gender).length !== 0)
    ) {
      let finalData = [];
      const data = filterAge(backData);
      finalData.push(...data);
      if (doctor.length !== 0) {
        const data = filterDoctor(finalData);
        filteredData.push(...data);
      }
      if (selectFmc.length !== 0) {
        const data = filterFmc(finalData);
        filteredData.push(...data);
      }
      if (startDate !== null && endDate !== null) {
        const data = filterDate(finalData);
        filteredData.push(...data);
      }
      if (Object.keys(gender).length !== 0) {
        const data = filterGender(finalData);
        filteredData.push(...data);
      }
    } else if (
      (selectFmc.length !== 0 &&
        doctor.length === 0 &&
        startDate === null &&
        endDate === null &&
        Object.keys(age).length === 0 &&
        Object.keys(gender).length !== 0) ||
      (selectFmc.length === 0 &&
        doctor.length !== 0 &&
        startDate === null &&
        endDate === null &&
        Object.keys(age).length === 0 &&
        Object.keys(gender).length !== 0) ||
      (selectFmc.length === 0 &&
        doctor.length === 0 &&
        startDate !== null &&
        endDate !== null &&
        Object.keys(age).length === 0 &&
        Object.keys(gender).length !== 0) ||
      (selectFmc.length === 0 &&
        doctor.length === 0 &&
        startDate === null &&
        endDate === null &&
        Object.keys(age).length !== 0 &&
        Object.keys(gender).length !== 0)
    ) {
      let finalData = [];
      const data = filterGender(backData);
      finalData.push(...data);
      if (doctor.length !== 0) {
        const data = filterDoctor(finalData);
        filteredData.push(...data);
      }
      if (selectFmc.length !== 0) {
        const data = filterFmc(finalData);
        filteredData.push(...data);
      }
      if (startDate !== null && endDate !== null) {
        const data = filterDate(finalData);
        filteredData.push(...data);
      }
      if (Object.keys(age).length !== 0) {
        const data = filterAge(finalData);
        filteredData.push(...data);
      }
    } else {
      let finalData = backData;
      if (Object.keys(gender).length !== 0) {
        const data = filterGender(finalData);
        finalData = [];
        finalData.push(...data);
      }
      if (doctor.length !== 0) {
        const data = filterDoctor(finalData);
        finalData = [];
        finalData.push(...data);
      }
      if (selectFmc.length !== 0) {
        const data = filterFmc(finalData);
        finalData = [];
        finalData.push(...data);
      }
      if (startDate !== null && endDate !== null) {
        const data = filterDate(finalData);
        finalData = [];
        finalData.push(...data);
      }
      if (Object.keys(age).length !== 0) {
        const data = filterAge(finalData);
        finalData = [];
        finalData.push(...data);
      }
      filteredData.push(...finalData);
    }
    // console.log(filteredData);
    generateChartData(filteredData);
    setData(filteredData);
  }, [selectFmc, doctor, startDate, endDate, age, gender]);

  // function to filter multipe fmc wise data
  const filterFmc = (data1) => {
    let value = [];
    for (let i = 0; i < selectFmc.length; i++) {
      let clinicfilter = data1.filter((d) => d.ClinicId === selectFmc[i].value);
      if (clinicfilter.length !== 0) {
        value.push(...clinicfilter);
      }
    }
    return value;
  };

  // function to filter multipe doctor wise data
  const filterDoctor = (data1) => {
    let value = [];
    for (let i = 0; i < doctor.length; i++) {
      let clinicfilter = data1.filter((d) => d.DoctorId === doctor[i].value);
      if (clinicfilter.length !== 0) {
        value.push(...clinicfilter);
      }
    }
    return value;
  };

  // function to filter date wise
  const filterDate = (data1) => {
    let value = [];
    // console.log(data1);
    let stDt = moment(startDate).subtract(1, 'day').format('YYYY-MM-DD');
    let enDt = moment(endDate).add(1, 'day').format('YYYY-MM-DD');
    let clinicfilter = data1.filter((d) =>
      moment(moment(d.TestDate).format('YYYY-MM-DD')).isBetween(stDt, enDt)
    );
    // console.log(clinicfilter);
    const sortedData = clinicfilter.sort(
      (a, b) =>
        new Date(a?.TestDate).getTime() - new Date(b?.TestDate).getTime()
    );
    value.push(...sortedData);
    return value;
  };

  // function to filter gender wise
  const filterGender = (data1) => {
    let value = [];
    for (let i = 0; i < gender.length; i++) {
      let clinicfilter = data1.filter((d) => d.Gender === gender[i].value);
      if (clinicfilter.length !== 0) {
        value.push(...clinicfilter);
      }
    }
    return value;
  };

  // function to filter age wise
  const filterAge = (data1) => {
    let value = [];
    if (age.value !== 'All') {
      let [startAge, endAge] = age.value.split('-');
      // console.log(startAge, endAge);
      let clinicfilter = data1.filter(
        (d) => d.age >= startAge && d.age <= endAge
      );
      value.push(...clinicfilter);
      return value;
    } else {
      return data1;
    }
  };

  // fmc select filter
  const handleMultiSelect = (opt) => {
    setMultiFilterShow(false);
    setMultiFilter([]);
    setMultiFilterData([]);
    setSelectFmc(opt);
  };

  // filter for options provided after pie chart of all the tests and multi select option is provided so it will filter accordingly
  const OptionsData = (e, chart) => {
    let options = e.target.options;
    let value = multiFilter.filter((d) => d.chart !== chart);
    let opt = [];
    for (let i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        opt.push(options[i].value);
      }
    }
    value.push({ label: opt, chart: chart });
    let filterDt = [];
    // console.log(value);
    for (let j = 0; j < value.length; j++) {
      if (
        value[j].chart === 'HealthScore_SCORE_TEXT' &&
        filterDt.length === 0
      ) {
        let fival = [];
        if (value[j].label.length !== 0) {
          for (let i = 0; i < value[j].label.length; i++) {
            // console.log(value[j].label[i]);
            let lbl = value[j].label[i];
            let dts = [];
            if (lbl !== '') {
              dts = data.filter(
                (d) =>
                  d.HealthScore_SCORE_TEXT === lbl &&
                  d.HealthScore_SCORE_TEXT !== null
              );
            } else {
              dts = data;
            }
            fival.push(...dts);
            // val.push(...fival);
            // console.log(fival);
            filterDt.push(...fival);
          }
        }
      } else if (
        value[j].chart === 'HealthScore_SCORE_TEXT' &&
        filterDt.length !== 0
      ) {
        let fival = [];
        if (value[j].label.length !== 0) {
          for (let i = 0; i < value[j].label.length; i++) {
            let lbl = value[j].label[i];
            let dts = [];
            if (lbl !== '') {
              dts = filterDt.filter(
                (d) =>
                  d.HealthScore_SCORE_TEXT === lbl &&
                  d.HealthScore_SCORE_TEXT !== null
              );
            } else {
              dts = filterDt;
            }
            fival.push(...dts);
          }
          filterDt = [];
          filterDt.push(...fival);
        }
      }
      if (
        value[j].chart === 'BloodGlucose_SCORE_TEXT' &&
        filterDt.length === 0
      ) {
        let fival = [];
        if (value[j].label.length !== 0) {
          for (let i = 0; i < value[j].label.length; i++) {
            // console.log(value[j].label[i]);
            let lbl = value[j].label[i];
            let dts = [];
            if (lbl !== '' && lbl !== 'Diabetic') {
              dts = data.filter(
                (d) =>
                  d.BloodGlucose_SCORE_TEXT === lbl &&
                  d.BloodGlucose_SCORE_TEXT !== null
              );
            } else if (lbl === 'Diabetic') {
              dts = data.filter(
                (d) =>
                  (d.BloodGlucose_SCORE_TEXT === 'Diabetic' &&
                    d.BloodGlucose_SCORE_TEXT !== null) ||
                  (d.BloodGlucose_SCORE_TEXT === 'High' &&
                    d.BloodGlucose_SCORE_TEXT !== null)
              );
            } else {
              dts = data;
            }
            fival.push(...dts);
          }
          filterDt.push(...fival);
        }
      } else if (
        value[j].chart === 'BloodGlucose_SCORE_TEXT' &&
        filterDt.length !== 0
      ) {
        let fival = [];
        // console.log("Dt", filterDt)
        if (value[j].label.length !== 0) {
          for (let i = 0; i < value[j].label.length; i++) {
            let lbl = value[j].label[i];
            let dts = [];
            if (lbl !== '' && lbl !== 'Diabetic') {
              dts = filterDt.filter(
                (d) =>
                  d.BloodGlucose_SCORE_TEXT === lbl &&
                  d.BloodGlucose_SCORE_TEXT !== null
              );
            } else if (lbl === 'Diabetic') {
              dts = data.filter(
                (d) =>
                  (d.BloodGlucose_SCORE_TEXT === 'Diabetic' &&
                    d.BloodGlucose_SCORE_TEXT !== null) ||
                  (d.BloodGlucose_SCORE_TEXT === 'High' &&
                    d.BloodGlucose_SCORE_TEXT !== null)
              );
            } else {
              dts = filterDt;
            }
            fival.push(...dts);
          }
          filterDt = [];
          filterDt.push(...fival);
        }
      }
      if (value[j].chart === 'HEMOGLOBIN_SCORE_TEXT' && filterDt.length === 0) {
        let fival = [];
        if (value[j].label.length !== 0) {
          for (let i = 0; i < value[j].label.length; i++) {
            // console.log(value[j].label[i]);
            let lbl = value[j].label[i];
            let dts = [];
            if (lbl !== '') {
              dts = data.filter(
                (d) =>
                  d.HEMOGLOBIN_SCORE_TEXT === lbl &&
                  d.HEMOGLOBIN_SCORE_TEXT !== null
              );
            } else {
              dts = data;
            }
            fival.push(...dts);
          }
          filterDt.push(...fival);
        }
      } else if (
        value[j].chart === 'HEMOGLOBIN_SCORE_TEXT' &&
        filterDt.length !== 0
      ) {
        let fival = [];
        if (value[j].label.length !== 0) {
          // console.log("Dt", filterDt)
          for (let i = 0; i < value[j].label.length; i++) {
            let lbl = value[j].label[i];
            let dts = [];
            if (lbl !== '') {
              dts = filterDt.filter(
                (d) =>
                  d.HEMOGLOBIN_SCORE_TEXT === lbl &&
                  d.HEMOGLOBIN_SCORE_TEXT !== null
              );
            } else {
              dts = filterDt;
            }
            fival.push(...dts);
          }
          filterDt = [];
          filterDt.push(...fival);
        }
      }
      if (value[j].chart === 'Cholestrol_SCORE_TEXT' && filterDt.length === 0) {
        let fival = [];
        if (value[j].label.length !== 0) {
          for (let i = 0; i < value[j].label.length; i++) {
            // console.log(value[j].label[i]);
            let lbl = value[j].label[i];
            let dts = [];
            if (lbl !== '') {
              dts = data.filter(
                (d) =>
                  d.Cholestrol_SCORE_TEXT === lbl &&
                  d.Cholestrol_SCORE_TEXT !== null
              );
            } else {
              dts = data;
            }
            fival.push(...dts);
          }
          filterDt.push(...fival);
        }
      } else if (
        value[j].chart === 'Cholestrol_SCORE_TEXT' &&
        filterDt.length !== 0
      ) {
        let fival = [];
        if (value[j].label.length !== 0) {
          // console.log("Dt", filterDt)
          for (let i = 0; i < value[j].label.length; i++) {
            let lbl = value[j].label[i];
            let dts = [];
            if (lbl !== '') {
              dts = filterDt.filter(
                (d) =>
                  d.Cholestrol_SCORE_TEXT === lbl &&
                  d.Cholestrol_SCORE_TEXT !== null
              );
            } else {
              dts = filterDt;
            }
            fival.push(...dts);
          }
          filterDt = [];
          filterDt.push(...fival);
        }
      }
      if (value[j].chart === 'UricAcid_SCORE_TEXT' && filterDt.length === 0) {
        let fival = [];
        if (value[j].label.length !== 0) {
          for (let i = 0; i < value[j].label.length; i++) {
            // console.log(value[j].label[i]);
            let lbl = value[j].label[i];
            let dts = [];
            if (lbl !== '') {
              dts = data.filter(
                (d) =>
                  d.UricAcid_SCORE_TEXT === lbl &&
                  d.UricAcid_SCORE_TEXT !== null
              );
            } else {
              dts = data;
            }
            fival.push(...dts);
          }
          filterDt.push(...fival);
        }
      } else if (
        value[j].chart === 'UricAcid_SCORE_TEXT' &&
        filterDt.length !== 0
      ) {
        let fival = [];
        if (value[j].label.length !== 0) {
          for (let i = 0; i < value[j].label.length; i++) {
            let lbl = value[j].label[i];
            let dts = [];
            if (lbl !== '') {
              dts = filterDt.filter(
                (d) =>
                  d.UricAcid_SCORE_TEXT === lbl &&
                  d.UricAcid_SCORE_TEXT !== null
              );
            } else {
              dts = filterDt;
            }
            fival.push(...dts);
          }
          filterDt = [];
          filterDt.push(...fival);
        }
      }
    }
    setMultiFilter(value);
    setMultiFilterData(filterDt);
    setMultiFilterShow(true);
    setSelectChartValue('');
    setSelectChartValue1('');
    // console.log(value)
  };

  // show patient details on click of bar chart data clicked
  const barchartdata = (dt, gender) => {
    // console.log(dt, gender);
    // diabeticBloodGlucose;
    // lowHemoglobin;
    // highCholesterol;
    // highUricAcid;
    let age = dt.point.category;
    let chartname = dt.point.series.name;
    // console.log(age, chartname);
    let finalData = [];
    if (age === '0-17') {
      let tabledt = gendercalcdata(chartname, 0, 17, gender);
      // console.log(tabledt);
      finalData.push(...tabledt);
    } else if (age === '18-40') {
      let tabledt = gendercalcdata(chartname, 18, 40, gender);
      finalData.push(...tabledt);
    } else if (age === '41-60') {
      let tabledt = gendercalcdata(chartname, 41, 60, gender);
      finalData.push(...tabledt);
    } else if (age === 'Above 60') {
      let tabledt = gendercalcdata(chartname, 61, 120, gender);
      finalData.push(...tabledt);
    }
    setAgeChartValue(`${chartname} - ${age}`);
    setAgeChartData(finalData);
    setAgeChartDataModel(true);
  };

  // filter data gender wise function
  const gendercalcdata = (chart, age1, age2, gender) => {
    if (chart === 'Diabetic') {
      return diabeticBloodGlucose.filter(
        (d) => d.age >= age1 && d.age <= age2 && d.Gender === gender
      );
    } else if (chart === 'Anaemic') {
      return lowHemoglobin.filter(
        (d) => d.age >= age1 && d.age <= age2 && d.Gender === gender
      );
    } else if (chart === 'High Cholesterol') {
      return highCholesterol.filter(
        (d) => d.age >= age1 && d.age <= age2 && d.Gender === gender
      );
    } else if (chart === 'High Uric Acid') {
      return highUricAcid.filter(
        (d) => d.age >= age1 && d.age <= age2 && d.Gender === gender
      );
    }
  };

  // overall pie chart option to be added to chart
  const options = {
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      // type: 'variablepie',
      height: '400px',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 5,
      spacingRight: 5,
      events: {
        load: function () {
          const chart = this,
            titleHeight = chart.title.alignOptions.height,
            updatedHeight = chart.chartHeight + titleHeight;
          chart.setSize(null, updatedHeight);
        },
      },
    },
    title: {
      text: '',
      style: {
        fontSize: '22px',
        fontWeight: 'bold',
      },
    },
    tooltip: {
      pointFormat: '{series.name}: {point.y}',
    },
    credits: {
      enabled: false,
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        size: '90%',
        height: '100%',
        dataLabels: {
          enabled: false,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
        },
        showInLegend: true,
      },
      series: {
        point: {
          events: {
            click: function (event) {
              // console.log(event);
              setTotalScoreValue(event.point.name);
              setTotalScoreDataModel(true);
            },
          },
        },
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 1200,
          },
          chartOptions: {
            legend: {
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal',
            },
            yAxis: {
              labels: {
                align: 'left',
                x: 0,
                y: -5,
              },
              title: {
                align: 'center',
              },
            },
            subtitle: {
              text: null,
            },
            credits: {
              enabled: false,
            },
          },
        },
      ],
    },
    series: [
      {
        name: '',
        colorByPoint: true,
        data: totalHealthScoreData,
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          connectorShape: 'crookedLine',
          crookDistance: '10%',
          distance: -35,
          style: {
            color: 'black',
            fontSize: '15px',
            textOutline: 'none',
          },
        },
        minPointSize: 10,
        innerSize: '20%',
        zMin: 0,
      },
    ],
    exporting: {
      buttons: {
        contextButton: {
          enabled: false,
        },
        printButton: {
          enabled: false,
        },
      },
    },
  };

  // male bar chart option to be added to chart
  const malebargraph = {
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: ['0-17', '18-40', '41-60', 'Above 60'],
      title: {
        text: 'Age Group',
      },
      crosshair: true,
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: '',
      },
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
      enabled: false,
    },
    tooltip: {
      // headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      // pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      //     '<td style="padding:0"><b>{point.y}</b></td></tr>',
      // footerFormat: '</table>',
      // shared: true,
      // useHTML: true
      pointFormat: '{series.name}: {point.y}',
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0,
        cursor: 'pointer',
      },
      series: {
        dataGrouping: {
          enabled: false,
        },
        point: {
          events: {
            click: function (event) {
              // console.log(event);
              barchartdata(event, 'Male');
            },
          },
        },
      },
    },
    series: ageGroupMaleChart,
  };

  // female bar chart option to be added to chart
  const femalebargraph = {
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: ['0-17', '18-40', '41-60', 'Above 60'],
      title: {
        text: 'Age Group',
      },
      crosshair: true,
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: '',
      },
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
      enabled: false,
    },
    tooltip: {
      // headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      // pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      //     '<td style="padding:0"><b>{point.y}</b></td></tr>',
      // footerFormat: '</table>',
      // shared: true,
      // useHTML: true
      pointFormat: '{series.name}: {point.y}',
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0,
        cursor: 'pointer',
      },
      series: {
        dataGrouping: {
          enabled: false,
        },
        point: {
          events: {
            click: function (event) {
              // console.log(event);
              barchartdata(event, 'Female');
            },
          },
        },
      },
    },
    series: ageGroupFemaleChart,
  };

  // noninvasive pie chart option to be added to chart
  const noninvasive = {
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height: '400px',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 5,
      spacingRight: 5,
    },
    title: {
      text: '',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
      },
    },
    tooltip: {
      pointFormat: '{series.name}: {point.y}',
    },
    credits: {
      enabled: false,
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        size: '100%',
        height: '100%',
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          distance: -30,
          filter: {
            property: 'percentage',
            operator: '>',
            value: 4,
          },
        },
        showInLegend: true,
      },
      series: {
        point: {
          events: {
            click: function (event) {
              // console.log(event);
              if (speciality.value === 'Sickle Cell') {
                setSelectChartValue1('Non-Invasive');
                setSelectChartParameter1(event.point.name);
              } else {
                setSelectChartValue('Non-Invasive');
                setSelectChartParameter(event.point.name);
              }
              setMultiFilterShow(false);
              handleClickScroll();
            },
          },
        },
      },
    },
    series: [
      {
        name: '',
        colorByPoint: true,
        data: healthScoreData,
        innerSize: '40%',
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 1200,
          },
          chartOptions: {
            legend: {
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal',
            },
            yAxis: {
              labels: {
                align: 'left',
                x: 0,
                y: -5,
              },
              title: {
                align: 'center',
              },
            },
            subtitle: {
              text: null,
            },
            credits: {
              enabled: false,
            },
          },
        },
      ],
    },
    options: {
      maintainAspectRatio: false,
      responsive: true,
    },
    exporting: {
      buttons: {
        contextButton: {
          enabled: false,
        },
        printButton: {
          enabled: false,
        },
      },
    },
  };

  // bloodglucose pie chart option to be added to chart
  const bloodsugar = {
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height: '400px',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      text: '',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
      },
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y}</b>',
    },
    credits: {
      enabled: false,
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        size: '100%',
        height: '100%',
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          distance: -35,
          filter: {
            property: 'percentage',
            operator: '>',
            value: 4,
          },
        },
        showInLegend: true,
      },
      series: {
        point: {
          events: {
            click: function (event) {
              // console.log(event);
              setSelectChartValue('Blood Glucose');
              setSelectChartParameter(event.point.name);
              setMultiFilterShow(false);
              handleClickScroll();
            },
          },
        },
      },
    },
    series: [
      {
        name: '',
        data: bloodGlucoseScoreData,
        innerSize: '40%',
      },
    ],
    options: {
      maintainAspectRatio: false,
      responsive: true,
    },
    exporting: {
      buttons: {
        contextButton: {
          enabled: false,
        },
        printButton: {
          enabled: false,
        },
      },
    },
  };

  // hemoglobin pie chart option to be added to chart
  const hemoglobin = {
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height: '400px',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      text: '',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
      },
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y}</b>',
    },
    credits: {
      enabled: false,
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        size: '100%',
        height: '100%',
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          distance: -35,
          filter: {
            property: 'percentage',
            operator: '>',
            value: 4,
          },
        },
        showInLegend: true,
      },
      series: {
        point: {
          events: {
            click: function (event) {
              // console.log(event);
              if (speciality.value === 'Sickle Cell') {
                setSelectChartValue1('Hemoglobin');
                setSelectChartParameter1(event.point.name);
              } else {
                setSelectChartValue('Hemoglobin');
                setSelectChartParameter(event.point.name);
              }

              setMultiFilterShow(false);
              handleClickScroll();
            },
          },
        },
      },
    },
    series: [
      {
        name: '',
        data: hemoglobinScoreData,
        innerSize: '40%',
      },
    ],
    options: {
      maintainAspectRatio: false,
      responsive: true,
    },
    exporting: {
      buttons: {
        contextButton: {
          enabled: false,
        },
        printButton: {
          enabled: false,
        },
      },
    },
  };

  // cholesterol pie chart option to be added to chart
  const cholesterol = {
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height: '400px',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      text: '',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
      },
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y}</b>',
    },
    credits: {
      enabled: false,
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        size: '100%',
        height: '100%',
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          distance: -35,
          filter: {
            property: 'percentage',
            operator: '>',
            value: 4,
          },
        },
        showInLegend: true,
      },
      series: {
        point: {
          events: {
            click: function (event) {
              // console.log(event);
              setSelectChartValue('Cholesterol');
              setSelectChartParameter(event.point.name);
              setMultiFilterShow(false);
              handleClickScroll();
            },
          },
        },
      },
    },
    series: [
      {
        name: '',
        data: cholesterolScoreData,
        innerSize: '40%',
      },
    ],
    options: {
      maintainAspectRatio: false,
      responsive: true,
    },
    exporting: {
      buttons: {
        contextButton: {
          enabled: false,
        },
        printButton: {
          enabled: false,
        },
      },
    },
  };

  // uricacid pie chart option to be added to chart
  const uricacid = {
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height: '400px',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      text: '',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
      },
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y}</b>',
    },
    credits: {
      enabled: false,
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        size: '100%',
        height: '100%',
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          distance: -30,
          filter: {
            property: 'percentage',
            operator: '>',
            value: 4,
          },
        },
        showInLegend: true,
      },
      series: {
        point: {
          events: {
            click: function (event) {
              // console.log(event);
              setSelectChartValue('Uric Acid');
              setSelectChartParameter(event.point.name);
              setMultiFilterShow(false);
              handleClickScroll();
            },
          },
        },
      },
    },
    series: [
      {
        name: '',
        data: uricAcidScoreData,
        innerSize: '40%',
      },
    ],
    options: {
      maintainAspectRatio: false,
      responsive: true,
    },
    exporting: {
      buttons: {
        contextButton: {
          enabled: false,
        },
        printButton: {
          enabled: false,
        },
      },
    },
  };

  // bmi pie chart option to be added to chart
  const bmi = {
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height: '400px',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      text: '',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
      },
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y}</b>',
    },
    credits: {
      enabled: false,
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        size: '100%',
        height: '100%',
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          distance: -35,
          filter: {
            property: 'percentage',
            operator: '>',
            value: 4,
          },
        },
        showInLegend: true,
      },
      series: {
        point: {
          events: {
            click: function (event) {
              // console.log(event);
              setSelectChartValue1('BMI');
              setSelectChartParameter1(event.point.name);
              setMultiFilterShow(false);
              // handleClickScroll();
              var height = document.body.scrollHeight;
              window.scroll(0, height);
            },
          },
        },
      },
    },
    series: [
      {
        name: '',
        data: bmiScoreData,
        innerSize: '40%',
      },
    ],
    options: {
      maintainAspectRatio: false,
      responsive: true,
    },
    exporting: {
      buttons: {
        contextButton: {
          enabled: false,
        },
        printButton: {
          enabled: false,
        },
      },
    },
  };

  // sickleSolubility pie chart option to be added to chart
  const sickleSolubility = {
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height: '400px',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      text: '',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
      },
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y}</b>',
    },
    credits: {
      enabled: false,
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        size: '100%',
        height: '100%',
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          distance: -35,
          filter: {
            property: 'percentage',
            operator: '>',
            value: 4,
          },
        },
        showInLegend: true,
      },
      series: {
        point: {
          events: {
            click: function (event) {
              // console.log(event);
              setSelectChartValue1('Sickle Cell');
              setSelectChartParameter1(event.point.name);
              setMultiFilterShow(false);
              // handleClickScroll();
              var height = document.body.scrollHeight;
              window.scroll(0, height);
            },
          },
        },
      },
    },
    series: [
      {
        name: '',
        data: sicklsolScoreData,
        innerSize: '40%',
      },
    ],
    options: {
      maintainAspectRatio: false,
      responsive: true,
    },
    exporting: {
      buttons: {
        contextButton: {
          enabled: false,
        },
        printButton: {
          enabled: false,
        },
      },
    },
  };

  // sickleRDT pie chart option to be added to chart
  const sickleRdt = {
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height: '400px',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      text: '',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
      },
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y}</b>',
    },
    credits: {
      enabled: false,
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        size: '100%',
        height: '100%',
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          distance: -35,
          filter: {
            property: 'percentage',
            operator: '>',
            value: 4,
          },
        },
        showInLegend: true,
      },
      series: {
        point: {
          events: {
            click: function (event) {
              // console.log(event);
              setSelectChartValue1('Sickle Cell');
              setSelectChartParameter1(event.point.name);
              setMultiFilterShow(false);
              // handleClickScroll();
              var height = document.body.scrollHeight;
              window.scroll(0, height);
            },
          },
        },
      },
    },
    series: [
      {
        name: '',
        data: sicklRDTScoreData,
        innerSize: '40%',
      },
    ],
    options: {
      maintainAspectRatio: false,
      responsive: true,
    },
    exporting: {
      buttons: {
        contextButton: {
          enabled: false,
        },
        printButton: {
          enabled: false,
        },
      },
    },
  };
  // non invasive line chart option to be added to chart on patient details in the bottom
  const noninvasivelinechart = {
    chart: {
      type: 'spline',
      scrollablePlotArea: {
        minWidth: 600,
        scrollPositionX: 1,
      },
    },
    title: {
      // text: "NON INVASIVE HEALTH SCORE",
      text: '',
    },
    xAxis: {
      categories: patientXLabels,
    },
    yAxis: {
      title: {
        text: 'Range',
      },
      min: 0,
      max: selectLineMax,
      tickInterval: 10,
      minorGridLineWidth: 0,
      gridLineWidth: 0,
      alternateGridColor: null,
      plotBands: selectLineBackGraph,
    },
    accessibility: {
      enabled: false,
    },
    plotOptions: {
      spline: {
        lineWidth: 2,
        dataLabels: {
          enabled: true,
          fontSize: '16px',
        },
      },
    },
    series: patientChartData,
    navigation: {
      menuItemStyle: {
        fontSize: '10px',
      },
    },
  };

  // blood glucose line chart option to be added to chart on patient details in the bottom
  const bloodglucoselinechart = {
    chart: {
      type: 'spline',
      scrollablePlotArea: {
        minWidth: 600,
        scrollPositionX: 1,
      },
    },
    title: {
      // text: "BLOOD GLUCOSE",
      text: '',
    },
    xAxis: {
      categories: bloodGlucosePatientXLabels,
    },
    yAxis: {
      title: {
        text: 'Range',
      },
      min: 0,
      max: bloodGlucoseSelectLineMax,
      tickInterval: 10,
      minorGridLineWidth: 0,
      gridLineWidth: 0,
      alternateGridColor: null,
      plotBands: bloodGlucoseSelectLineBackGraph,
    },
    accessibility: {
      enabled: false,
    },
    plotOptions: {
      spline: {
        lineWidth: 2,
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: bloodGlucosePatientChartData,
    navigation: {
      menuItemStyle: {
        fontSize: '10px',
      },
    },
  };

  // hemoglobin line chart option to be added to chart on patient details in the bottom
  const hemoglobinlinechart = {
    chart: {
      type: 'spline',
      scrollablePlotArea: {
        minWidth: 600,
        scrollPositionX: 1,
      },
    },
    title: {
      // text: "HEMOGLOBIN",
      text: '',
    },
    xAxis: {
      categories: hemoglobinPatientXLabels,
    },
    yAxis: {
      title: {
        text: 'Range',
      },
      min: 0,
      max: hemoglobinSelectLineMax,
      tickInterval: 10,
      minorGridLineWidth: 0,
      gridLineWidth: 0,
      alternateGridColor: null,
      plotBands: hemoglobinSelectLineBackGraph,
    },
    accessibility: {
      enabled: false,
    },
    plotOptions: {
      spline: {
        lineWidth: 2,
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: hemoglobinPatientChartData,
    navigation: {
      menuItemStyle: {
        fontSize: '10px',
      },
    },
  };

  // cholesterol line chart option to be added to chart on patient details in the bottom
  const cholesterollinechart = {
    chart: {
      type: 'spline',
      scrollablePlotArea: {
        minWidth: 600,
        scrollPositionX: 1,
      },
    },
    title: {
      // text: "CHOLESTEROL",
      text: '',
    },
    xAxis: {
      categories: cholesterolPatientXLabels,
    },
    yAxis: {
      title: {
        text: 'Range',
      },
      min: 0,
      max: cholesterolSelectLineMax,
      tickInterval: 10,
      minorGridLineWidth: 0,
      gridLineWidth: 0,
      alternateGridColor: null,
      plotBands: cholesterolSelectLineBackGraph,
    },
    accessibility: {
      enabled: false,
    },
    plotOptions: {
      spline: {
        lineWidth: 2,
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: cholesterolPatientChartData,
    navigation: {
      menuItemStyle: {
        fontSize: '10px',
      },
    },
  };

  // urci line chart option to be added to chart on patient details in the bottom
  const uricacidlinechart = {
    chart: {
      type: 'spline',
      scrollablePlotArea: {
        minWidth: 600,
        scrollPositionX: 1,
      },
    },
    title: {
      text: '',
      // text: "URIC ACID",
    },
    xAxis: {
      categories: uricAcidPatientXLabels,
    },
    yAxis: {
      title: {
        text: 'Range',
      },
      min: 0,
      max: uricAcidSelectLineMax,
      tickInterval: 2,
      minorGridLineWidth: 0,
      gridLineWidth: 0,
      alternateGridColor: null,
      plotBands: uricAcidSelectLineBackGraph,
    },
    accessibility: {
      enabled: false,
    },
    plotOptions: {
      spline: {
        lineWidth: 2,
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: uricAcidPatientChartData,
    navigation: {
      menuItemStyle: {
        fontSize: '10px',
      },
    },
  };
  // bmi line chart option to be added to chart on patient details in the bottom
  const bmilinechart = {
    chart: {
      type: 'spline',
      scrollablePlotArea: {
        minWidth: 600,
        scrollPositionX: 1,
      },
    },
    title: {
      // text: "BLOOD GLUCOSE",
      text: '',
    },
    xAxis: {
      categories: bmiPatientXLabels,
    },
    yAxis: {
      title: {
        text: 'Range',
      },
      min: 0,
      max: bmiSelectLineMax,
      tickInterval: 10,
      minorGridLineWidth: 0,
      gridLineWidth: 0,
      alternateGridColor: null,
      plotBands: bmiSelectLineBackGraph,
    },
    accessibility: {
      enabled: false,
    },
    plotOptions: {
      spline: {
        lineWidth: 2,
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: bmiPatientChartData,
    navigation: {
      menuItemStyle: {
        fontSize: '10px',
      },
    },
  };

  // set table data on click of line graph
  const tableData = (data1) => {
    return <Table data={data1} viewDetails={createGraphData} />;
  };
  // set table data on click of line graph
  const tableData1 = (data1, showdata) => {
    // console.log(showdata);
    return (
      <BmiTable
        data={data1}
        showdata={showdata}
        viewDetails={createGraphData1}
      />
    );
  };
  // set graph data for line chart
  const createGraphData = (id, gender) => {
    setChartLoading(true);
    setPatientChartData([]);
    setPatientDetail([]);
    setPatientXLabels([]);
    setSelectLineBackGraph([]);
    setBloodGlucosePatientChartData([]);
    setBloodGlucosePatientXLabels([]);
    setBloodGlucoseSelectLineBackGraph([]);
    setHemoglobinPatientChartData([]);
    setHemoglobinPatientXLabels([]);
    setHemoglobinSelectLineBackGraph([]);
    setCholesterolPatientChartData([]);
    setCholesterolPatientXLabels([]);
    setCholesterolSelectLineBackGraph([]);
    setUricAcidPatientChartData([]);
    setUricAcidPatientXLabels([]);
    setUricAcidSelectLineBackGraph([]);
    let fmc = selectFmc.length !== 0 ? selectFmc : fmcs;
    setLoaderText('Fetching data ...');
    axios
      .post(
        `${link.apiUrl1}/api/misdashboarddata/getHealthScore/patient/alltests`,
        { fmc: fmc, id: id }
      )
      .then((res) => {
        let healthscore = [];
        let testlabels = [];
        let bloodsugar = [];
        let testlabels1 = [];
        let hemoglobin = [];
        let testlabels2 = [];
        let cholesterol = [];
        let testlabels3 = [];
        let uricacid = [];
        let testlabels4 = [];
        setLoaderText('Analyzing data ...');
        const resdt = res.data.testData[0].noninvasive.healthscoredata
          ?.sort(function (a, b) {
            return (
              new Date(a?.TestDate).getTime() - new Date(b?.TestDate).getTime()
            );
          })
          .reverse()
          .slice(0, 5)
          .reverse();
        const resdt1 = res.data.testData[0].bloodsugar.bloodsugardata
          ?.sort(function (a, b) {
            return (
              new Date(a?.TestDate).getTime() - new Date(b?.TestDate).getTime()
            );
          })
          .reverse()
          .slice(0, 5)
          .reverse();
        const resdt2 = res.data.testData[0].hemoglobin.hemoglobindata
          ?.sort(function (a, b) {
            return (
              new Date(a?.TestDate).getTime() - new Date(b?.TestDate).getTime()
            );
          })
          .reverse()
          .slice(0, 5)
          .reverse();
        const resdt3 = res.data.testData[0].cholesterol.cholesteroldata
          ?.sort(function (a, b) {
            return (
              new Date(a?.TestDate).getTime() - new Date(b?.TestDate).getTime()
            );
          })
          .reverse()
          .slice(0, 5)
          .reverse();
        const resdt4 = res.data.testData[0].uricacid.uricaciddata
          ?.sort(function (a, b) {
            return (
              new Date(a?.TestDate).getTime() - new Date(b?.TestDate).getTime()
            );
          })
          .reverse()
          .slice(0, 5)
          .reverse();
        // console.log(resdt);
        for (let i = 0; i < resdt.length; i++) {
          healthscore.push(Number(resdt[i].Result));
          testlabels.push(resdt[i].TestDate);
        }
        for (let i = 0; i < resdt1.length; i++) {
          bloodsugar.push(Number(resdt1[i].Result));
          testlabels1.push(resdt1[i].TestDate);
        }
        for (let i = 0; i < resdt2.length; i++) {
          hemoglobin.push(Number(resdt2[i].Result));
          testlabels2.push(resdt2[i].TestDate);
        }
        for (let i = 0; i < resdt3.length; i++) {
          cholesterol.push(Number(resdt3[i].Result));
          testlabels3.push(resdt3[i].TestDate);
        }
        for (let i = 0; i < resdt4.length; i++) {
          uricacid.push(Number(resdt4[i].Result));
          testlabels4.push(resdt4[i].TestDate);
        }
        // console.log("test", res.data);
        let chartdata = [
          {
            name: 'Non Invasive Score',
            fontSize: '16px',
            data: healthscore,
            color: '#585858',
          },
        ];
        let chartdata1 = [
          {
            name: 'Blood Glucose',
            fontSize: '16px',
            data: bloodsugar,
            color: '#585858',
          },
        ];
        let chartdata2 = [
          {
            name: 'Hemoglobin',
            fontSize: '16px',
            data: hemoglobin,
            color: '#585858',
          },
        ];
        let chartdata3 = [
          {
            name: 'Cholesterol',
            fontSize: '16px',
            data: cholesterol,
            color: '#585858',
          },
        ];
        let chartdata4 = [
          {
            name: 'Uric Acid',
            fontSize: '16px',
            data: uricacid,
            color: '#585858',
          },
        ];
        // noninvasive

        setSelectLineBackGraph([
          {
            from: 0,
            to: 49.9,
            color: High1,
            label: {
              text: 'Poor',
              style: linestyle,
            },
          },
          {
            // Fair
            from: 49.9,
            to: 80.9,
            color: Fair1,
            label: {
              text: 'Fair',
              style: linestyle,
            },
          },
          {
            // Good
            from: 80.9,
            to: 90.9,
            color: Low1,
            label: {
              text: 'Good',
              style: linestyle,
            },
          },
          {
            // Optimal
            from: 90.9,
            to: 100,
            color: Optimal1,
            label: {
              text: 'Optimal',
              style: linestyle,
            },
          },
        ]);
        // blood glucose
        let bloodsugarrange = [];
        for (
          let i = 0;
          i < res.data.testData[0].bloodsugar.range1.length;
          i++
        ) {
          let rs = res.data.testData[0].bloodsugar.range1[i];
          if (rs.rangeText === 'Extremely Low') {
            bloodsugarrange.push({
              from: rs.range_from,
              to: Number(rs.range_to) + 0.9,
              color: ExtremelyLow1,
              label: {
                text: 'Extremely Low',
                style: linestyle,
              },
            });
          } else if (rs.rangeText === 'Low') {
            bloodsugarrange.push({
              from:
                res.data.testData[0].bloodsugar.range1.length === 3
                  ? Number(rs.range_from)
                  : Number(rs.range_from) - 0.1,
              to: Number(rs.range_to) + 0.9,
              color: Low1,
              label: {
                text: 'Low',
                style: linestyle,
              },
            });
          } else if (rs.rangeText === 'Normal') {
            bloodsugarrange.push({
              from: Number(rs.range_from) - 0.1,
              to: Number(rs.range_to) + 0.9,
              color: Optimal1,
              label: {
                text: 'Normal',
                style: linestyle,
              },
            });
          } else if (rs.rangeText === 'Pre-diabetic') {
            bloodsugarrange.push({
              from: Number(rs.range_from) - 0.1,
              to: Number(rs.range_to) + 0.9,
              color: Fair1,
              label: {
                text: 'Pre Diabetic',
                style: linestyle,
              },
            });
          } else if (rs.rangeText === 'Diabetic') {
            bloodsugarrange.push({
              from: Number(rs.range_from) - 0.1,
              to: 999,
              color: High1,
              label: {
                text: 'Diabetic',
                style: linestyle,
              },
            });
          } else if (rs.rangeText === 'High') {
            bloodsugarrange.push({
              from: Number(rs.range_from) - 0.1,
              to: 999,
              color: High1,
              label: {
                text: 'High',
                style: linestyle,
              },
            });
          }
        }
        // console.log(bloodsugarrange);
        let hemoglobinrange = [];
        for (
          let i = 0;
          i < res.data.testData[0].hemoglobin.range2.length;
          i++
        ) {
          let rs = res.data.testData[0].hemoglobin.range2[i];
          if (rs.rangeText === 'Low') {
            hemoglobinrange.push({
              from: Number(rs.range_from),
              to: Number(rs.range_to) + 0.09,
              color: Low1,
              label: {
                text: 'Low',
                style: linestyle,
              },
            });
          } else if (rs.rangeText === 'Normal') {
            hemoglobinrange.push({
              from: Number(rs.range_from) - 0.01,
              to: Number(rs.range_to) + 0.09,
              color: Optimal1,
              label: {
                text: 'Normal',
                style: linestyle,
              },
            });
          } else if (rs.rangeText === 'High') {
            hemoglobinrange.push({
              from: Number(rs.range_from) - 0.01,
              to: 100,
              color: High1,
              label: {
                text: 'High',
                style: linestyle,
              },
            });
          }
        }
        // console.log(hemoglobinrange)
        let cholesterolrange = [];
        for (
          let i = 0;
          i < res.data.testData[0].cholesterol.range3.length;
          i++
        ) {
          let rs = res.data.testData[0].cholesterol.range3[i];
          if (rs.rangeText === 'Less') {
            cholesterolrange.push({
              from: Number(rs.range_from),
              to: Number(rs.range_to) + 0.9,
              color: Low1,
              label: {
                text: 'Less',
                style: linestyle,
              },
            });
          } else if (rs.rangeText === 'Optimal') {
            cholesterolrange.push({
              from: Number(rs.range_from) - 0.1,
              to: Number(rs.range_to) + 0.9,
              color: Optimal1,
              label: {
                text: 'Optimal',
                style: linestyle,
              },
            });
          } else if (rs.rangeText === 'Border Line') {
            cholesterolrange.push({
              from: Number(rs.range_from) - 0.1,
              to: Number(rs.range_to) + 0.9,
              color: Fair1,
              label: {
                text: 'Border Line',
                style: linestyle,
              },
            });
          } else if (rs.rangeText === 'High') {
            cholesterolrange.push({
              from: Number(rs.range_from) - 0.1,
              to: 999,
              color: High1,
              label: {
                text: 'High',
                style: linestyle,
              },
            });
          }
        }
        // console.log(cholesterolrange);
        let uricacidrange = [];
        for (let i = 0; i < res.data.testData[0].uricacid.range4.length; i++) {
          let rs = res.data.testData[0].uricacid.range4[i];
          if (rs.rangeText === 'Low') {
            uricacidrange.push({
              from: Number(rs.range_from),
              to: Number(rs.range_to) + 0.09,
              color: Low1,
              label: {
                text: 'Low',
                style: linestyle,
              },
            });
          } else if (rs.rangeText === 'Normal') {
            uricacidrange.push({
              from: Number(rs.range_from) - 0.01,
              to: Number(rs.range_to) + 0.09,
              color: Optimal1,
              label: {
                text: 'Normal',
                style: linestyle,
              },
            });
          } else if (rs.rangeText === 'High') {
            uricacidrange.push({
              from: Number(rs.range_from) - 0.01,
              to: rs.range_to,
              color: High1,
              label: {
                text: 'High',
                style: linestyle,
              },
            });
          }
        }
        // console.log(uricacidrange)
        // non invasive
        setSelectLineMax(100);
        setPatientChartData(chartdata);
        setPatientDetail(resdt);
        setPatientXLabels(testlabels);
        // blood glucose
        setBloodGlucoseSelectLineMax(999);
        setBloodGlucoseSelectLineBackGraph(bloodsugarrange);
        setBloodGlucosePatientChartData(chartdata1);
        setBloodGlucosePatientXLabels(testlabels1);
        // hemoglobin
        setHemoglobinSelectLineMax(100);
        setHemoglobinSelectLineBackGraph(hemoglobinrange);
        setHemoglobinPatientChartData(chartdata2);
        setHemoglobinPatientXLabels(testlabels2);
        // cholesterol
        setCholesterolSelectLineMax(999);
        setCholesterolSelectLineBackGraph(cholesterolrange);
        setCholesterolPatientChartData(chartdata3);
        setCholesterolPatientXLabels(testlabels3);
        // uric acid
        setUricAcidSelectLineMax(10);
        setUricAcidSelectLineBackGraph(uricacidrange);
        setUricAcidPatientChartData(chartdata4);
        setUricAcidPatientXLabels(testlabels4);
        setTimeout(() => {
          setChartLoading(false);
          setLoaderText('Loading ...');
        }, 3000);
      })
      .catch((err) => {
        console.log(err);
        setChartLoading(false);
        setLoaderText('Loading ...');
      });
    setShowPatientDetail(true);
    // setPatientId(id);
    // setPatientGender(gender);
  };
  // set graph data for line chart
  const createGraphData1 = (name, gender) => {
    // setChartLoading(true);
    setPatientChartData([]);
    setPatientDetail([]);
    setPatientXLabels([]);
    setSelectLineBackGraph([]);
    setBmiPatientChartData([]);
    setBmiPatientXLabels([]);
    setBmiSelectLineBackGraph([]);
    // let fmc = selectFmc.length !== 0 ? selectFmc : fmcs;
    // setLoaderText("Fetching data ...");
    // axios.post(`${link.apiUrl1}/api/misdashboarddata/getHealthScore/patient/alltests`, { fmc: fmc, id: id }).then((res) => {
    //     let healthscore = [];
    //     let testlabels = [];
    //     let bmi = [];
    //     let testlabels1 = [];
    //     setLoaderText("Analyzing data ...");
    //     const resdt = res.data.testData[0].noninvasive.healthscoredata?.sort(function (a, b) {
    //         return new Date(a?.TestDate).getTime() - new Date(b?.TestDate).getTime()
    //     }).reverse().slice(0, 5).reverse();
    //     // const resdt1 = res.data.testData[0].bmi.bmidata?.sort(function (a, b) {
    //     //     return new Date(a?.TestDate).getTime() - new Date(b?.TestDate).getTime()
    //     // }).reverse().slice(0, 5).reverse()
    //     // console.log(resdt);
    //     // for (let i = 0; i < resdt.length; i++) {
    //     //     healthscore.push(Number(resdt[i].Result));
    //     //     testlabels.push(resdt[i].TestDate);
    //     // }
    //     // for (let i = 0; i < resdt1.length; i++) {
    //     //     bmi.push(Number(resdt1[i].Result));
    //     //     testlabels1.push(resdt1[i].TestDate);
    //     // }
    //     // console.log("test",resdt);
    //     // let chartdata = [{
    //     //     name: 'Non Invasive Score',
    //     //     fontSize: "16px",
    //     //     data: healthscore,
    //     //     color: "#585858"
    //     // }];
    //     // let chartdata1 = [{
    //     //     name: 'BMI',
    //     //     fontSize: "16px",
    //     //     data: bmi,
    //     //     color: "#585858"
    //     // }];
    //     // noninvasive

    //     // setSelectLineBackGraph([{
    //     //     from: 0,
    //     //     to: 49.9,
    //     //     color: High1,
    //     //     label: {
    //     //         text: 'Poor',
    //     //         style: linestyle
    //     //     }
    //     // }, { // Fair
    //     //     from: 49.9,
    //     //     to: 80.9,
    //     //     color: Fair1,
    //     //     label: {
    //     //         text: 'Fair',
    //     //         style: linestyle
    //     //     }
    //     // }, { // Good
    //     //     from: 80.9,
    //     //     to: 90.9,
    //     //     color: Low1,
    //     //     label: {
    //     //         text: 'Good',
    //     //         style: linestyle
    //     //     }
    //     // }, { // Optimal
    //     //     from: 90.9,
    //     //     to: 100,
    //     //     color: Optimal1,
    //     //     label: {
    //     //         text: 'Optimal',
    //     //         style: linestyle
    //     //     }
    //     // }]);
    //     //bmi
    //     // let bmirange = [];
    //     // for (let i = 0; i < res.data.testData[0].bmi.range1.length; i++) {
    //     //     let rs = res.data.testData[0].bmi.range1[i];
    //     //     if (rs.rangeText === "Underweight") {
    //     //         bmirange.push({
    //     //             from: rs.range_from,
    //     //             to: Number(rs.range_to) + 0.9,
    //     //             color: ExtremelyLow1,
    //     //             label: {
    //     //                 text: 'Underweight',
    //     //                 style: linestyle
    //     //             }
    //     //         })
    //     //     } else if (rs.rangeText === "Normal") {
    //     //         bmirange.push({
    //     //             from: res.data.testData[0].bmi.range1.length === 3 ? Number(rs.range_from) : Number(rs.range_from) - 0.1,
    //     //             to: Number(rs.range_to) + 0.9,
    //     //             color: Low1,
    //     //             label: {
    //     //                 text: 'Normal',
    //     //                 style: linestyle
    //     //             }
    //     //         })
    //     //     } else if (rs.rangeText === "Increased") {
    //     //         bmirange.push({
    //     //             from: Number(rs.range_from) - 0.1,
    //     //             to: Number(rs.range_to) + 0.9,
    //     //             color: Optimal1,
    //     //             label: {
    //     //                 text: 'Increased',
    //     //                 style: linestyle
    //     //             }
    //     //         })
    //     //     } else if (rs.rangeText === "High") {
    //     //         bmirange.push({
    //     //             from: Number(rs.range_from) - 0.1,
    //     //             to: Number(rs.range_to) + 0.9,
    //     //             color: Fair1,
    //     //             label: {
    //     //                 text: 'High',
    //     //                 style: linestyle
    //     //             }
    //     //         })
    //     //     } else if (rs.rangeText === "Very High") {
    //     //         bmirange.push({
    //     //             from: Number(rs.range_from) - 0.1,
    //     //             to: 999,
    //     //             color: High1,
    //     //             label: {
    //     //                 text: 'Very High',
    //     //                 style: linestyle
    //     //             }
    //     //         })
    //     //     }
    //     // }
    //     // console.log(bmirange);

    //     // console.log(uricacidrange)
    //     // non invasive
    //     // setSelectLineMax(100);
    //     // setPatientChartData(chartdata);
    //     setPatientDetail(resdt);
    //     // setPatientXLabels(testlabels);
    //     // bmi
    //     // setBmiSelectLineMax(999);
    //     // setBmiSelectLineBackGraph(bmirange);
    //     // setBmiPatientChartData(chartdata1);
    //     // setBmiPatientXLabels(testlabels1);

    //     setTimeout(() => {
    //         setChartLoading(false);
    //         setLoaderText("Loading ...");
    //     }, 3000);
    // }).catch((err) => {
    //     console.log(err);
    //     setChartLoading(false);
    //     setLoaderText("Loading ...");
    // })
    setShowPatientDetail1(true);
    setPatientName(name);
    // setPatientGender(gender);
  };

  const handleClickScroll = () => {
    const element = document.getElementById('tablescroll');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  // console.log(selectChartValue1, selectChartParameter1)
  return (
    <div>
      {isLoading ? (
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              position: 'fixed',
              left: '50%',
              top: '50%',
            }}
            className="align-middle justify-content-center"
          >
            <div
              className="spinner-border text-primary"
              style={{ width: '3rem', height: '3rem' }}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
          <h5
            style={{
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              position: 'fixed',
              left: '48%',
              top: '57%',
            }}
          >
            {loaderText}
          </h5>
        </>
      ) : (
        <section className="dashboard-bg">
          <div className="container-fluid">
            <div className="col-md-12 rightsectiondeshbord" id="chartsbar">
              <div className="rightsec">
                <div className="topheadersec row">
                  <div
                    className="dashboardtop"
                    style={{ backgroundColor: '#0D92D4' }}
                  >
                    <h2 style={{ textTransform: 'uppercase' }}>
                      {campName !== '' ? `${campName} -` : null} HEALTH CAMP
                    </h2>
                  </div>
                  <div className="logo col-md-2">
                    {logo !== null ? (
                      <img src={`${link.cdnurl}/misdashboard/${logo}`} alt="" />
                    ) : (
                      <img src={logo1} alt="" />
                    )}
                  </div>
                  {/* form newaddon */}
                  <div className="col-md-10">
                    {/* <form> */}
                    <div className="range">
                      <div className="testselectbox1 fifteenpercent">
                        <Select
                          isMulti={false}
                          closeMenuOnSelect={false}
                          name="speciality"
                          //value={speciality}
                          onChange={(opt) => {
                            setMultiFilterShow(false);
                            setMultiFilter([]);
                            setMultiFilterData([]);
                            setSpeciality(opt);
                            if (speciality.value !== 'Obesity') {
                              setShowObesity(false);
                              setSelectChartParameter1('');
                              setSelectChartValue1('');
                            } else if (speciality.value !== 'Sickle Cell') {
                              setShowSickle(false);
                              setSelectChartValue1('');
                            }
                          }}
                          options={specialityList}
                          placeholder="Select Speciality"
                          styles={{
                            menuList: (styles, { data }) => ({
                              ...styles,

                              '::-webkit-scrollbar': {
                                width: '9px',
                                display: 'block',
                                WebkitTransition:
                                  'background-color .2s linear, opacity .2s linear',
                              },
                              '::-webkit-scrollbar-track': {
                                background: 'transparent',
                              },
                              '::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '5px',
                              },
                              '::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                              },
                            }),
                            singleValue: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                            }),
                            control: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                              fontSize: '14px',
                            }),
                            menu: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                            }),
                          }}
                        />
                      </div>
                      <div className="testselectbox1 fifteenpercent">
                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          name="selectFmc"
                          value={selectFmc}
                          onChange={handleMultiSelect}
                          options={fmcs}
                          placeholder="Select Location"
                          hideSelectedOptions={false}
                          components={{
                            Option,
                          }}
                          styles={{
                            menuList: (styles, { data }) => ({
                              ...styles,
                              height: '200px',
                              '::-webkit-scrollbar': {
                                width: '9px',
                                display: 'block',
                                WebkitTransition:
                                  'background-color .2s linear, opacity .2s linear',
                              },
                              '::-webkit-scrollbar-track': {
                                background: 'transparent',
                              },
                              '::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '5px',
                              },
                              '::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                              },
                            }),
                            multiValueLabel: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                            }),
                            control: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                              fontSize: '14px',
                            }),
                            menu: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                            }),
                            input: (styles, { data }) => ({
                              ...styles,
                              width: 'auto',
                            }),
                          }}
                        />
                      </div>
                      <div className="testselectbox1 fifteenpercent">
                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          name="doctor"
                          value={doctor}
                          onChange={(opt) => {
                            setMultiFilterShow(false);
                            setMultiFilter([]);
                            setMultiFilterData([]);
                            setDoctor(opt);
                          }}
                          options={doctorList}
                          placeholder="Select Doctor"
                          hideSelectedOptions={false}
                          components={{
                            Option,
                          }}
                          styles={{
                            multiValueLabel: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                            }),
                            control: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                              fontSize: '14px',
                            }),
                            menu: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                              height: 'auto',
                            }),
                          }}
                        />
                      </div>
                      <div className="newcustdateofbirth twentypercent">
                        <DatePicker
                          selected={startDate}
                          onChange={(dates) => {
                            const [start, end] = dates;
                            setStartDate(start);
                            setEndDate(end);
                          }}
                          startDate={startDate}
                          endDate={endDate}
                          autoComplete="off"
                          placeholderText="Select Date Range"
                          // showYearDropdown
                          // showMonthDropdown
                          // dropdownMode="select"
                          // dateFormat="dd/MM/yyyy"
                          selectsRange
                          isClearable={true}
                        />
                      </div>
                      <div className="testselectbox1 fifteenpercent">
                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          name="gender"
                          value={gender}
                          onChange={(opt) => {
                            setMultiFilterShow(false);
                            setMultiFilter([]);
                            setMultiFilterData([]);
                            setGender(opt);
                          }}
                          options={genderList}
                          hideSelectedOptions={false}
                          components={{
                            Option,
                          }}
                          placeholder="Select Gender"
                          styles={{
                            menuList: (styles, { data }) => ({
                              ...styles,
                              '::-webkit-scrollbar': {
                                width: '9px',
                                display: 'block',
                                WebkitTransition:
                                  'background-color .2s linear, opacity .2s linear',
                              },
                              '::-webkit-scrollbar-track': {
                                background: 'transparent',
                              },
                              '::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '5px',
                              },
                              '::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                              },
                            }),
                            singleValue: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                            }),
                            control: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                              fontSize: '14px',
                            }),
                            menu: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                            }),
                          }}
                        />
                      </div>
                      <div className="testselectbox1 fifteenpercent">
                        <Select
                          isMulti={false}
                          closeMenuOnSelect={false}
                          name="age"
                          value={age}
                          onChange={(opt) => {
                            setMultiFilterShow(false);
                            setMultiFilter([]);
                            setMultiFilterData([]);
                            setAge(opt);
                          }}
                          options={ageList}
                          placeholder="Select Age"
                          styles={{
                            menuList: (styles, { data }) => ({
                              ...styles,

                              '::-webkit-scrollbar': {
                                width: '9px',
                                display: 'block',
                                WebkitTransition:
                                  'background-color .2s linear, opacity .2s linear',
                              },
                              '::-webkit-scrollbar-track': {
                                background: 'transparent',
                              },
                              '::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '5px',
                              },
                              '::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                              },
                            }),
                            singleValue: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                            }),
                            control: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                              fontSize: '14px',
                            }),
                            menu: (styles, { data }) => ({
                              ...styles,
                              textAlign: 'start',
                            }),
                          }}
                        />
                      </div>
                      <Button
                        size="sm"
                        onClick={() => {
                          navigate('/');
                        }}
                      >
                        Log Out
                      </Button>
                    </div>
                    {/* </form> */}
                  </div>
                </div>

                <div className="container-fluid">
                  <div className="row addspace">
                    <div className="col-md-6 tmedata1">
                      <div className="boxes-overview">
                        <div className="tme">
                          <div className="tmedata">
                            <p>
                              TOTAL PARTICIPANTS:{' '}
                              {data && data.length !== 0 ? data.length : '--'}
                            </p>
                            <p>
                              MALE:{' '}
                              {data && data.length !== 0
                                ? data.filter((d) => d.Gender === 'Male').length
                                : '--'}
                            </p>
                            <p>
                              FEMALE:
                              {data && data.length !== 0
                                ? data.filter((d) => d.Gender === 'Female')
                                  .length
                                : '--'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="boxes-overview">
                        <div className="box">
                          <h2>
                            Health Score:{' '}
                            {isNaN(totalHealthScorePercent)
                              ? 0
                              : totalHealthScorePercent}
                            %{' '}
                            <i
                              onClick={() => {
                                setOverallHealthScoreModal(true);
                              }}
                              className="fas fa-info-circle finpoint"
                              style={{ marginLeft: '5px' }}
                            ></i>
                          </h2>
                        </div>
                        {speciality.value === 'Obesity' ? (
                          <div
                            className="box"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              var height = document.body.scrollHeight;
                              window.scroll(0, height);
                              setShowObesity(true);
                            }}
                          >
                            <h2>Obesity Parameter</h2>
                          </div>
                        ) : speciality.value === 'Sickle Cell' ? (
                          <>
                            <div
                              className="box"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                var height = document.body.scrollHeight;
                                window.scroll(0, height);
                                setShowSickle(true);
                              }}
                            >
                              <h2>Sickle Cell</h2>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </div>
                  {showObesity && speciality.value === 'Obesity' ? (
                    <>
                      <div className="row Tabs">
                        <h2
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            backgroundColor: '#0D92D4',
                          }}
                        >
                          Obesity Details
                        </h2>
                        <div className="col-md-12">
                          <div
                            className="tabsec"
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <div className="tablink">
                              <div className="genderContainer">
                                <p className="gen-para text-center">
                                  BMI (%){' '}
                                  <i
                                    onClick={() => {
                                      setBmiScoreModal(true);
                                    }}
                                    className="fas fa-info-circle"
                                  ></i>
                                </p>
                                <p className="gen-para text-center">
                                  {bmiCount} Tests
                                </p>
                                <div
                                  id="healthpiechartbs"
                                  style={{ height: '400px' }}
                                >
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={bmi}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : showSickle && speciality.value === 'Sickle Cell' ? (
                    <>
                      <div className="row Tabs">
                        <h2
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            backgroundColor: '#0D92D4',
                          }}
                        >
                          Sickle Cell Details
                        </h2>
                        <div className="col-md-12">
                          <div
                            className="tabsec"
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <div className="tablink">
                              <div className="genderContainer">
                                <p className="gen-para text-center">
                                  Non Invasive (%){' '}
                                  <i
                                    onClick={() => {
                                      setHealthScoreModal(true);
                                    }}
                                    className="fas fa-info-circle"
                                  ></i>
                                </p>
                                <h5 className="gen-para text-center">
                                  {nonInvcCount} Tests
                                </h5>
                                <div
                                  id="healthpiechartnoninv"
                                  style={{ height: '400px' }}
                                >
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={noninvasive}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="tablink">
                              <div className="genderContainer">
                                <p className="gen-para text-center">
                                  Hemoglobin (%){' '}
                                  <i
                                    onClick={() => {
                                      setHemoglobinScoreModal(true);
                                    }}
                                    className="fas fa-info-circle"
                                  ></i>
                                </p>
                                <h5 className="gen-para text-center">
                                  {hemoglobinCount} Tests
                                </h5>
                                <div
                                  id="healthpiecharthemo"
                                  style={{ height: '400px' }}
                                >
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={hemoglobin}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="tablink">
                              <div className="genderContainer">
                                <p className="gen-para text-center">
                                  Sickle Cell Solubility (%){' '}
                                  <i
                                    onClick={() => {
                                      setSickleSolScoreModal(true);
                                    }}
                                    className="fas fa-info-circle"
                                  ></i>
                                </p>
                                <h5 className="gen-para text-center">
                                  {sicklesolCount} Tests
                                </h5>
                                <div
                                  id="healthpiechartbs"
                                  style={{ height: '400px' }}
                                >
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={sickleSolubility}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="tablink">
                              <div className="genderContainer">
                                <p className="gen-para text-center">
                                  Sickle Cell RDT (%){' '}
                                  <i
                                    onClick={() => {
                                      setSickleRDTScoreModal(true);
                                    }}
                                    className="fas fa-info-circle"
                                  ></i>
                                </p>
                                <h5 className="gen-para text-center">
                                  {sicklerdtCount} Tests
                                </h5>
                                <div
                                  id="healthpiechartbs"
                                  style={{ height: '400px' }}
                                >
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={sickleRdt}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="row tabview pt40 pb40">
                        <div className="bgcolorshadow addmargin col-md-4 col-lg-4 col-xl-4">
                          <div className="healthpiecharttitlesec">
                            <h4 style={{ fontWeight: '600' }}>
                              HEALTH SCORE CLASSIFICATION (%){' '}
                              <i
                                onClick={() => {
                                  setTotalScoreModal(true);
                                }}
                                className="fas fa-info-circle finpoint"
                              ></i>
                            </h4>
                          </div>
                          <div id="healthpiechart">
                            <HighchartsReact
                              highcharts={Highcharts}
                              options={options}
                            />
                          </div>
                        </div>
                        <div className="bgcolorshadow addmargin col-md-4 col-lg-4 col-xl-4">
                          <div className="healthpiecharttitlesec">
                            <h4 style={{ fontWeight: '600' }}>
                              Age Group Wise Health Parameters - Males (%)
                            </h4>
                          </div>
                          <div id="healthpiechart">
                            <HighchartsReact
                              highcharts={Highcharts}
                              options={malebargraph}
                            />
                          </div>
                        </div>
                        <div className="bgcolorshadow addmargin col-md-4 col-lg-4 col-xl-4">
                          <div className="healthpiecharttitlesec">
                            <h4 style={{ fontWeight: '600' }}>
                              Age Group Wise Health Parameters - Females (%)
                            </h4>
                          </div>
                          <div id="healthpiechart">
                            <HighchartsReact
                              highcharts={Highcharts}
                              options={femalebargraph}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row Tabs">
                        <div className="col-md-12">
                          <div className="tabsec">
                            <div className="tablink">
                              <div className="genderContainer">
                                <p className="gen-para text-center">
                                  Non Invasive (%){' '}
                                  <i
                                    onClick={() => {
                                      setHealthScoreModal(true);
                                    }}
                                    className="fas fa-info-circle"
                                  ></i>
                                </p>
                                <h5 className="gen-para text-center">
                                  {nonInvcCount} Test
                                </h5>
                                <div
                                  id="healthpiechartnoninv"
                                  style={{ height: '400px' }}
                                >
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={noninvasive}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="tablink">
                              <div className="genderContainer">
                                <p className="gen-para text-center">
                                  Bloodsugar Random (%){' '}
                                  <i
                                    onClick={() => {
                                      setBloodGlucoseScoreModal(true);
                                    }}
                                    className="fas fa-info-circle"
                                  ></i>
                                </p>
                                <h5 className="gen-para text-center">
                                  {bloodglucoseCount} Test
                                </h5>
                                <div
                                  id="healthpiechartbs"
                                  style={{ height: '400px' }}
                                >
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={bloodsugar}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="tablink">
                              <div className="genderContainer">
                                <p className="gen-para text-center">
                                  Hemoglobin (%){' '}
                                  <i
                                    onClick={() => {
                                      setHemoglobinScoreModal(true);
                                    }}
                                    className="fas fa-info-circle"
                                  ></i>
                                </p>
                                <h5 className="gen-para text-center">
                                  {hemoglobinCount} Test
                                </h5>
                                <div
                                  id="healthpiecharthemo"
                                  style={{ height: '400px' }}
                                >
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={hemoglobin}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="tablink">
                              <div className="genderContainer">
                                <p className="gen-para text-center">
                                  Cholesterol (%){' '}
                                  <i
                                    onClick={() => {
                                      setCholesterolScoreModal(true);
                                    }}
                                    className="fas fa-info-circle"
                                  ></i>
                                </p>
                                <h5 className="gen-para text-center">
                                  {cholestrolcount} Test
                                </h5>
                                <div
                                  id="healthpiechartcholes"
                                  style={{ height: '400px' }}
                                >
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={cholesterol}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="tablink">
                              <div className="genderContainer">
                                <p className="gen-para text-center">
                                  Uric Acid (%){' '}
                                  <i
                                    onClick={() => {
                                      setUricAcidScoreModal(true);
                                    }}
                                    className="fas fa-info-circle"
                                  ></i>
                                </p>
                                <h5 className="gen-para text-center">
                                  {uricCount} Test
                                </h5>
                                <div
                                  id="healthpiechartcholes1"
                                  style={{ height: '400px' }}
                                >
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={uricacid}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="footerdropdown">
                        <div className="form">
                          <form>
                            <div className="range">
                              <select
                                onChange={(e) =>
                                  OptionsData(e, 'HealthScore_SCORE_TEXT')
                                }
                                multiple
                                className="text custom"
                                placeholder="sagar"
                              >
                                <option value="">NON INVASIVE</option>
                                <option value="Bad">Poor</option>
                                <option value="Average">Fair</option>
                                <option value="Good">Good</option>
                                <option value="Optimal">Optimal</option>
                              </select>
                              <select
                                onChange={(e) =>
                                  OptionsData(e, 'BloodGlucose_SCORE_TEXT')
                                }
                                multiple
                                className="text custom"
                                placeholder="sagar"
                              >
                                <option value="">BLOOD SUGAR</option>
                                <option value="Diabetic">Diabetic</option>
                                <option value="Pre-diabetic">
                                  Pre-Diabetic
                                </option>
                                <option value="Normal">Normal</option>
                                <option value="Low">Low</option>
                                <option value="Very Low">Very Low</option>
                              </select>
                              <select
                                onChange={(e) =>
                                  OptionsData(e, 'HEMOGLOBIN_SCORE_TEXT')
                                }
                                multiple
                                className="text custom"
                                placeholder="sagar"
                              >
                                <option value="">HEMOGLOBIN</option>
                                {/* <option value='Extremely Low'>Extremely Low</option> */}
                                <option value="Low">Low</option>
                                <option value="Normal">Normal</option>
                                <option value="High">High</option>
                                {/* <option value='Extremely High'>Extremely High</option> */}
                              </select>
                              <select
                                onChange={(e) =>
                                  OptionsData(e, 'Cholestrol_SCORE_TEXT')
                                }
                                multiple
                                className="text custom"
                                placeholder="sagar"
                              >
                                <option value="">TOTAL CHOLESTEROL</option>
                                <option value="High">High</option>
                                <option value="Border Line">Border line</option>
                                <option value="Optimal">Normal</option>
                                <option value="Less">Less</option>
                              </select>
                              <select
                                onChange={(e) =>
                                  OptionsData(e, 'UricAcid_SCORE_TEXT')
                                }
                                multiple
                                className="text custom"
                                placeholder="sagar"
                              >
                                <option value="">URIC ACID</option>
                                <option value="High">High</option>
                                <option value="Normal">Normal</option>
                                <option value="Low">Low</option>
                              </select>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div
                        className="col-md-12 bgcolorshadow1"
                        style={{ overflowX: 'auto' }}
                        id="tablescroll"
                      >
                        <div
                          className="titletable"
                          style={{ backgroundColor: '#0D92D4' }}
                        >
                          {selectChartValue !== '' ? (
                            <h4 style={{ textTransform: 'uppercase' }}>
                              {selectChartValue} - {selectChartParameter}
                            </h4>
                          ) : (
                            <h4>PATIENT DETAILS</h4>
                          )}
                        </div>
                        {selectChartValue === 'Non-Invasive' ? (
                          <div>
                            {selectChartParameter === 'Optimal'
                              ? tableData(optimalHealthScore)
                              : selectChartParameter === 'Good'
                                ? tableData(goodHealthScore)
                                : selectChartParameter === 'Fair'
                                  ? tableData(averageHealthScore)
                                  : selectChartParameter === 'Poor'
                                    ? tableData(poorHealthScore)
                                    : null}
                          </div>
                        ) : selectChartValue === 'Blood Glucose' ? (
                          <div>
                            {selectChartParameter === 'Diabetic'
                              ? tableData(diabeticBloodGlucose)
                              : selectChartParameter === 'Pre-Diabetic'
                                ? tableData(preDiabeticBloodGlucose)
                                : selectChartParameter === 'Normal'
                                  ? tableData(normalBloodGlucose)
                                  : selectChartParameter === 'Low'
                                    ? tableData(lowBloodGlucose)
                                    : selectChartParameter === 'Very Low'
                                      ? tableData(veryLowBloodGlucose)
                                      : null}
                          </div>
                        ) : selectChartValue === 'Hemoglobin' ? (
                          <div>
                            {/* selectChartParameter === "Extermely High" ? tableData(veryHighHemoglobin) : */}
                            {selectChartParameter === 'High'
                              ? tableData(highHemoglobin)
                              : selectChartParameter === 'Normal'
                                ? tableData(normalHemoglobin)
                                : selectChartParameter === 'Low'
                                  ? tableData(lowHemoglobin)
                                  : null}
                            {/* selectChartParameter === "Extremely Low" ? tableData(veryLowHemoglobin) : */}
                          </div>
                        ) : selectChartValue === 'Cholesterol' ? (
                          <div>
                            {selectChartParameter === 'High'
                              ? tableData(highCholesterol)
                              : selectChartParameter === 'Normal'
                                ? tableData(normalCholesterol)
                                : selectChartParameter === 'Border Line'
                                  ? tableData(borderLineCholesterol)
                                  : selectChartParameter === 'Less'
                                    ? tableData(lessCholesterol)
                                    : null}
                          </div>
                        ) : selectChartValue === 'Uric Acid' ? (
                          <div>
                            {selectChartParameter === 'High'
                              ? tableData(highUricAcid)
                              : selectChartParameter === 'Normal'
                                ? tableData(normalUricAcid)
                                : selectChartParameter === 'Low'
                                  ? tableData(lowUricAcid)
                                  : null}
                          </div>
                        ) : null}
                        {multiFilterShow ? tableData(multiFilterData) : null}
                      </div>
                    </>
                  )}
                </div>

                <Modal
                  show={overallHealthScoreModal}
                  onHide={() => setOverallHealthScoreModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <b>HEALTH SCORE CLASSIFICATION</b>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Health Score % is the overall average health score
                    percentage of all the participants.
                    <br />
                    <br />
                    It considers all the parameters (Invasive and Non Invasive)
                    performed on each participant.
                    <br />
                    <br />A health score is then generated at each participant
                    level which is then aggregated and average percentage is
                    generated.
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setOverallHealthScoreModal(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={totalScoreModal}
                  onHide={() => setOverallHealthScoreModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <b>HEALTH SCORE CLASSIFICATION</b>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    The Health Score depends upon the over-all assessment of an
                    individual.
                    <br />
                    <br />
                    Non invasive parameters along with Hemoglobin, Cholesterol,
                    Blood Sugar and Uric acid parameters are considered for the
                    individual health score.
                    <br />
                    <br />
                    In case the test result is within the normal limits, the
                    score is higher and if the result is either lower or higher
                    than the normal limits, the score reduces depending on the
                    variation observed.
                    <br />
                    <br />
                    The Health Score(%) is the average percentage calculated
                    based on overall health scores of all participants for all
                    the tests conducted.
                    <br />
                    <br />
                    The Health score percentage changes as per the age and
                    gender filters selected.
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setTotalScoreModal(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={healthScoreModal}
                  onHide={() => setHealthScoreModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Non Invasive</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Non-invasive parameters include BMI, BMR, Body Fat, Visceral
                    fat, Muscle mass, Body water, Body Mass and Bone Mass.
                    <br />
                    <br />
                    This gives us a clear picture of the physical health of the
                    person.
                    <br />
                    <br />A higher health score is an indication of superior
                    physical health.
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setHealthScoreModal(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={bloodGlucoseScoreModal}
                  onHide={() => setBloodGlucoseScoreModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Bloodsugar Random</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Glucose is the main sugar found in your blood. Your blood
                    carries glucose to all of your body's cells to use for
                    energy. Diabetes is a result of too much glucose in the
                    blood. If blood glucose stays high for too long, diabetes
                    can damage the heart, blood vessels, eyes, kidneys and
                    nerves over time causing chronic problems and premature
                    death.
                    <br />
                    <br />
                    According to WHO, in 2012, diabetes was the direct cause of
                    1.5 million deaths worldwide.
                    <br />
                    <br />
                    <table>
                      <tbody>
                        <tr className="addcolor1">
                          <th>Blood Glucose</th>
                          <th>Range</th>
                          <th></th>
                        </tr>
                        <tr className="addcolor2">
                          <td></td>
                          <td>From</td>
                          <td>To</td>
                        </tr>
                        <tr className="addcolor3">
                          <td>Extremely Low</td>
                          <td>Less than 53</td>
                          <td></td>
                        </tr>
                        <tr className="addcolor4">
                          <td>Low</td>
                          <td>54</td>
                          <td>70</td>
                        </tr>
                        <tr className="addcolor3">
                          <td>Optimal</td>
                          <td>71</td>
                          <td>140</td>
                        </tr>
                        <tr className="addcolor4">
                          <td>Pre diabetic</td>
                          <td>141</td>
                          <td>200</td>
                        </tr>
                        <tr className="addcolor3">
                          <td>Diabetic</td>
                          <td>Higher than 200</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setBloodGlucoseScoreModal(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={hemoglobinScoreModal}
                  onHide={() => setHemoglobinScoreModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Hemoglobin</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Hemoglobin is a type of globular protein present in red
                    blood cells (RBCs), which transports oxygen in our body
                    through blood.
                    <br />
                    <br />
                    If a person has too low hemoglobin, there will be a
                    decreased capacity of the blood to carry oxygen to the
                    body’s tissues.
                    <br />
                    <br />
                    This results in symptoms such as fatigue, weakness,
                    dizziness and shortness of breath.
                    <br />
                    <br />
                    An Anemic work force may result in decrease in optimum
                    output of the workforce.
                    <br />
                    <br />
                    <table>
                      <tbody>
                        <tr className="addcolor5">
                          <th>Hemoglobin</th>
                          <th>Range</th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                        <tr className="addcolor6">
                          <td></td>
                          <td>
                            From
                            <br />
                            (Females)
                          </td>
                          <td>
                            To
                            <br />
                            (Females)
                          </td>
                          <td>
                            From
                            <br />
                            (Males)
                          </td>
                          <td>
                            To
                            <br />
                            (Males)
                          </td>
                        </tr>
                        <tr className="addcolor3">
                          <td>Extremely Low</td>
                          <td>Less than 5</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr className="addcolor6">
                          <td>Low</td>
                          <td>5.1</td>
                          <td>11.9</td>
                          <td>5.1</td>
                          <td>13.5</td>
                        </tr>
                        <tr className="addcolor3">
                          <td>Optimal</td>
                          <td>12</td>
                          <td>15.5</td>
                          <td>13.6</td>
                          <td>17.5</td>
                        </tr>
                        <tr className="addcolor6">
                          <td>High</td>
                          <td>15.6</td>
                          <td>20</td>
                          <td>17.6</td>
                          <td>20</td>
                        </tr>
                        <tr className="addcolor3">
                          <td>Extremely High</td>
                          <td>Higher than 20</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setHemoglobinScoreModal(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={cholesterolScoreModal}
                  onHide={() => setCholesterolScoreModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Cholesterol</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Your body needs cholesterol to build healthy cells, but high
                    levels of cholesterol can increase your risk of heart
                    disease. With high cholesterol, you can develop fatty
                    deposits in your blood vessels. Eventually, these deposits
                    grow, making it difficult for enough blood to flow through
                    your arteries.
                    <br />
                    <br />
                    High cholesterol can be inherited, but it's often the result
                    of unhealthy lifestyle choices, which make it preventable
                    and treatable. A healthy diet, regular exercise and
                    sometimes medication can help reduce high cholesterol.
                    <br />
                    <br />
                    <table>
                      <tbody>
                        <tr className="addcolor1">
                          <th>Cholesterol</th>
                          <th>Range</th>
                          <th></th>
                        </tr>
                        <tr className="addcolor2">
                          <td></td>
                          <td>From</td>
                          <td>To</td>
                        </tr>
                        <tr className="addcolor3">
                          <td>Low</td>
                          <td>Less than 124</td>
                          <td></td>
                        </tr>
                        <tr className="addcolor4">
                          <td>Optimal</td>
                          <td>125</td>
                          <td>200</td>
                        </tr>
                        <tr className="addcolor3">
                          <td>Borderline</td>
                          <td>201</td>
                          <td>239</td>
                        </tr>
                        <tr className="addcolor4">
                          <td>High</td>
                          <td>Higher than 239</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setCholesterolScoreModal(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={uricAcidScoreModal}
                  onHide={() => setUricAcidScoreModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Uric acid</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Uric acid is a waste product found in blood. It’s created
                    when the body breaks down chemicals called purines. Most
                    uric acid dissolves in the blood, passes through the kidneys
                    and leaves the body in urine. Food and drinks high in
                    purines also increase the level of uric acid. These include:
                    Seafood (especially salmon, shrimp, lobster and sardines)
                    Red meat, Organ meats like liver. Food and drinks with high
                    fructose corn syrup, and alcohol (especially beer, including
                    non-alcoholic beer)
                    <br />
                    <br />
                    If too much uric acid stays in the body, a condition called
                    hyperuricemia will occur. Hyperuricemia can cause crystals
                    of uric acid (or urate) to form. These crystals can settle
                    in the joints and cause gout, a form of arthritis that can
                    be very painful. They can also settle in the kidneys and
                    form kidney stones. If untreated, high uric acid levels may
                    eventually lead to permanent bone, joint and tissue damage,
                    kidney disease and heart disease. Research has also shown a
                    link between high uric acid levels and type 2 diabetes, high
                    blood pressure, and fatty liver disease.
                    <br />
                    <br />
                    <table>
                      <tbody>
                        <tr className="addcolor5">
                          <th>Uric Acid</th>
                          <th>Range</th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                        <tr className="addcolor6">
                          <td></td>
                          <td>
                            From
                            <br />
                            (Females)
                          </td>
                          <td>
                            To
                            <br />
                            (Females)
                          </td>
                          <td>
                            From
                            <br />
                            (Males)
                          </td>
                          <td>
                            To
                            <br />
                            (Males)
                          </td>
                        </tr>

                        <tr>
                          <td>Low</td>
                          <td>0</td>
                          <td>2.5</td>
                          <td>0</td>
                          <td>3.4</td>
                        </tr>
                        <tr>
                          <td>Optimal</td>
                          <td>2.6</td>
                          <td>6</td>
                          <td>3.5</td>
                          <td>7.7</td>
                        </tr>
                        <tr>
                          <td>High</td>
                          <td>6.1</td>
                          <td>10</td>
                          <td>7.8</td>
                          <td>10</td>
                        </tr>
                      </tbody>
                    </table>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setUricAcidScoreModal(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={bmiScoreModal}
                  onHide={() => setBmiScoreModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>BMI</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    BMI is a measurement that takes into account the height and
                    weight. It is a method of determining whether you may be
                    underweight, average weight, overweight, or obese. BMI is
                    not a diagnostic tool nor is it a measurement of body fat
                    percentage. A high BMI may or may not be an indicator of
                    high body fat, but it doesn't necessarily mean that a person
                    is overweight or obese and it alone is not a direct
                    indicator of health.
                    <table>
                      <tbody>
                        <tr className="addcolor1">
                          <th>BMI</th>
                          <th>Range</th>
                          <th></th>
                        </tr>
                        <tr className="addcolor2">
                          <td></td>
                          <td>From</td>
                          <td>To</td>
                        </tr>
                        <tr className="addcolor3">
                          <td>Underweight</td>
                          <td>0</td>
                          <td>18.5</td>
                        </tr>
                        <tr className="addcolor4">
                          <td>Normal</td>
                          <td>18.51</td>
                          <td>24.99</td>
                        </tr>
                        <tr className="addcolor3">
                          <td>Increased</td>
                          <td>25</td>
                          <td>29.99</td>
                        </tr>
                        <tr className="addcolor4">
                          <td>High</td>
                          <td>30</td>
                          <td>34.99</td>
                        </tr>
                        <tr className="addcolor3">
                          <td>Very High</td>
                          <td>above 34.99</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setBmiScoreModal(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
                <Modal
                  show={sickleSolScoreModal}
                  onHide={() => setSickleSolScoreModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Sickle Cell Solubility</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Sickle cell disease (SCD) comprises a group of genetic
                    disorders affecting hemoglobin, the oxygen-carrying protein
                    in red blood cells. In SCD, a genetic mutation leads to the
                    production of abnormal hemoglobin S, causing red blood cells
                    to take on a rigid, sickle shape, leading to potential
                    complications.
                    <br />
                    The sickle cell solubility test screens for hemoglobin S
                    presence, characteristic of SCD. If blood becomes less
                    soluble during the test, it indicates abnormal hemoglobin.
                    Confirmatory tests like hemoglobin electrophoresis or
                    high-performance liquid chromatography (HPLC) are typically
                    employed for precise identification of hemoglobin types and
                    proportions in the blood.
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setSickleSolScoreModal(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
                <Modal
                  show={sickleRDTScoreModal}
                  onHide={() => setSickleRDTScoreModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Sickle Cell RDT</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Sickle cell disease (SCD) comprises a group of genetic
                    disorders affecting hemoglobin, the oxygen-carrying protein
                    in red blood cells. In SCD, a genetic mutation leads to the
                    production of abnormal hemoglobin S, causing red blood cells
                    to take on a rigid, sickle shape, leading to potential
                    complications.
                    <br />
                    Individuals with the sickle cell trait inherit one normal
                    hemoglobin gene (usually hemoglobin A) and one abnormal
                    hemoglobin gene (hemoglobin S).
                    <br />
                    The sickle cell trait test is a test used to detect the
                    presence of hemoglobin S. If hemoglobin S is found, it
                    indicates that the person has the sickle cell trait. It's
                    important to note that individuals with the sickle cell
                    trait generally do not experience the same severe symptoms
                    and complications as those with sickle cell disease.
                    However, carriers of the trait can pass the gene to their
                    children.
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setSickleRDTScoreModal(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  dialogClassName="fullwidth"
                  show={totalScoreDataModel}
                  onHide={() => setTotalScoreDataModel(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      {' '}
                      <h4>
                        PATIENTS DETAILS -{' '}
                        <span style={{ textTransform: 'uppercase' }}>
                          {totalScoreValue}
                        </span>
                      </h4>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {totalScoreValue === 'Optimal'
                      ? tableData(optimalTotalHealthScore)
                      : totalScoreValue === 'Good'
                        ? tableData(goodTotalHealthScore)
                        : totalScoreValue === 'Fair'
                          ? tableData(averageTotalHealthScore)
                          : totalScoreValue === 'Poor'
                            ? tableData(poorTotalHealthScore)
                            : null}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setTotalScoreDataModel(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  dialogClassName="fullwidth"
                  show={ageChartDataModel}
                  onHide={() => setAgeChartDataModel(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <h4>
                        PATIENTS DETAILS -{' '}
                        <span style={{ textTransform: 'uppercase' }}>
                          {ageChartValue}
                        </span>
                      </h4>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>{tableData(ageChartData)}</Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setAgeChartDataModel(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  backdrop="static"
                  dialogClassName="fullwidth"
                  show={showPatientDetail}
                  onHide={() => {
                    setShowPatientDetail(false);
                  }}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <h4>PATIENTS DETAILS</h4>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body
                    className="overflow-auto"
                    style={{ height: '500px' }}
                  >
                    <h3 className="text-center text-uppercase">
                      Patient Name:- {patientDetail?.[0]?.PatientName}
                    </h3>
                    {chartLoading ? (
                      <>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'fixed',
                            left: '50%',
                            top: '40%',
                          }}
                          className="align-middle justify-content-center"
                        >
                          <div
                            className="spinner-border text-primary"
                            style={{ width: '3rem', height: '3rem' }}
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                        <h5
                          style={{
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'fixed',
                            left: '48%',
                            top: '47%',
                          }}
                        >
                          {loaderText}
                        </h5>
                      </>
                    ) : (
                      <Row>
                        <Col md="6">
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={noninvasivelinechart}
                          />
                        </Col>
                        <Col md="6">
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={bloodglucoselinechart}
                          />
                        </Col>
                        <Col md="6">
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={hemoglobinlinechart}
                          />
                        </Col>
                        <Col md="6">
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={cholesterollinechart}
                          />
                        </Col>
                        <Col md="6">
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={uricacidlinechart}
                          />
                        </Col>
                      </Row>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setShowPatientDetail(false);
                      }}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
                {/* new   */}
                <Modal
                  backdrop="static"
                  dialogClassName="fullwidth"
                  show={showPatientDetail1}
                  onHide={() => {
                    setShowPatientDetail1(false);
                  }}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <h4>PATIENTS DETAILS</h4>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body
                    className="overflow-auto"
                    style={{ height: '500px' }}
                  >
                    <h3 className="text-center text-uppercase">
                      {/* Patient Name:- {patientDetail?.[0]?.PatientName} */}
                      Patient Name:- {patientName}
                    </h3>
                    {chartLoading ? (
                      <>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'fixed',
                            left: '50%',
                            top: '40%',
                          }}
                          className="align-middle justify-content-center"
                        >
                          <div
                            className="spinner-border text-primary"
                            style={{ width: '3rem', height: '3rem' }}
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                        <h5
                          style={{
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'fixed',
                            left: '48%',
                            top: '47%',
                          }}
                        >
                          {loaderText}
                        </h5>
                      </>
                    ) : (
                      <Row>
                        {selectChartParameter1 === 'Underweight' ? (
                          <>
                            <Col md="1"></Col>
                            <Col
                              md="5"
                              style={{
                                backgroundColor: 'rgb(164 230 124)',
                                borderRadius: '30px',
                                margin: '10px',
                              }}
                            >
                              <h3
                                style={{
                                  textAlign: 'center',
                                  padding: '10px',
                                  backgroundColor: 'rgb(125 190 241)',
                                  borderRadius: '30px',
                                  margin: '15px 50px 15px 50px',
                                }}
                              >
                                Diet
                              </h3>
                              <h4>Caloric Intake</h4>
                              <p>
                                Ensure you consume enough calories to support
                                healthy weight gain.
                              </p>
                              <h4>Protein-Rich Foods</h4>
                              <p>
                                Include lean protein sources for muscle
                                development and overall growth.
                              </p>
                              <h4>Healthy Fats</h4>
                              <p>
                                Incorporate sources like avocados, nuts, and
                                olive oil for concentrated energy.
                              </p>
                              <h4>Frequent Meals and Snacks</h4>
                              <p>
                                Eat smaller, more frequent meals and snacks
                                throughout the day.
                              </p>
                              <h4>Consult a Professional</h4>
                              <p>
                                Seek guidance from a healthcare professional or
                                dietitian for personalized advice and
                                monitoring. Remember, gradual and healthy weight
                                gain is the goal, and individual needs may vary
                              </p>
                            </Col>
                            <Col
                              md="5"
                              style={{
                                backgroundColor: 'rgb(125 190 241)',
                                borderRadius: '30px',
                                margin: '10px',
                              }}
                            >
                              <h3
                                style={{
                                  textAlign: 'center',
                                  padding: '10px',
                                  backgroundColor: 'rgb(164 230 124)',
                                  borderRadius: '30px',
                                  margin: '15px 50px 15px 50px',
                                }}
                              >
                                Exercises
                              </h3>
                              <h4>Strength Training with Light Weights</h4>
                              <p>
                                Use light dumbbells or resistance bands for
                                exercises targeting different muscle groups.
                              </p>
                              <h4>Yoga or Pilates</h4>
                              <p>
                                Both practices improve flexibility, core
                                strength, and promote relaxation.
                              </p>
                              <h4>Walking or Light Jogging</h4>
                              <p>
                                Engage in gentle cardiovascular activities like
                                walking or light jogging for overall fitness.
                              </p>
                              <h4>Bodyweight Exercises</h4>
                              <p>
                                Include bodyweight exercises such as squats,
                                lunges, push-ups, and planks for strength and
                                stability.
                              </p>
                              <h4>Swimming</h4>
                              <p>
                                Swimming is a low-impact, full-body workout
                                that's easy on the joints. Always start at a
                                comfortable intensity and progress gradually. If
                                you have any health concerns or conditions,
                                consult with a healthcare professional or
                                fitness expert for personalized advice tailored
                                to your specific needs and goals.
                              </p>
                            </Col>
                            <Col md="1"></Col>
                          </>
                        ) : selectChartParameter1 === 'Normal' ? (
                          <>
                            <Col md="1"></Col>
                            <Col
                              md="5"
                              style={{
                                backgroundColor: 'rgb(164 230 124)',
                                borderRadius: '30px',
                                margin: '10px',
                              }}
                            >
                              <h3
                                style={{
                                  textAlign: 'center',
                                  padding: '10px',
                                  backgroundColor: 'rgb(125 190 241)',
                                  borderRadius: '30px',
                                  margin: '15px 50px 15px 50px',
                                }}
                              >
                                Diet
                              </h3>
                              <h4>Balanced Diet</h4>
                              <p>
                                Maintain a balanced diet with a variety of
                                fruits, vegetables, whole grains, lean proteins,
                                and healthy fats.
                              </p>
                              <h4>Portion Control</h4>
                              <p>
                                Be mindful of portion sizes to avoid overeating
                                and maintain a healthy caloric balance.
                              </p>
                              <h4>Regular Physical Activity</h4>
                              <p>
                                Incorporate regular exercise into your routine
                                for overall health and weight maintenance.
                              </p>
                              <h4>Hydration</h4>
                              <p>
                                Stay well-hydrated with water and limit the
                                consumption of sugary drinks.
                              </p>
                              <h4>Mindful Eating</h4>
                              <p>
                                Pay attention to hunger and fullness cues, and
                                avoid emotional or stress-related eating. For
                                individuals within this BMI range, the key is to
                                focus on overall health, maintaining a balanced
                                lifestyle, and preventing unhealthy weight
                                fluctuations. Regular check-ins with healthcare
                                professionals can help ensure that you are on
                                track with your health goals.
                              </p>
                            </Col>
                            <Col
                              md="5"
                              style={{
                                backgroundColor: 'rgb(125 190 241)',
                                borderRadius: '30px',
                                margin: '10px',
                              }}
                            >
                              <h3
                                style={{
                                  textAlign: 'center',
                                  padding: '10px',
                                  backgroundColor: 'rgb(164 230 124)',
                                  borderRadius: '30px',
                                  margin: '15px 50px 15px 50px',
                                }}
                              >
                                Exercises
                              </h3>
                              <h4>Running or Brisk Walking</h4>
                              <p>
                                Excellent for cardiovascular health. Start with
                                a brisk walk and gradually progress to jogging
                                or running.
                              </p>
                              <h4>Bodyweight Exercises</h4>
                              <p>
                                Include squats, lunges, push-ups, and planks for
                                strength training using your own body weight.
                              </p>
                              <h4>Cycling</h4>
                              <p>
                                Whether outdoors or on a stationary bike,
                                cycling is a low-impact cardio exercise that
                                also engages the lower body muscles.
                              </p>
                              <h4>Yoga</h4>
                              <p>
                                Enhances flexibility, balance, and promotes
                                relaxation. Choose a style that suits your
                                preferences, such as Vinyasa or Hatha.
                              </p>
                              <h4>High-Intensity Interval Training (HIIT)</h4>
                              <p>
                                Incorporate short bursts of high-intensity
                                exercises like jumping jacks, burpees, or
                                mountain climbers, followed by brief periods of
                                rest. Remember to listen to your body, start at
                                a comfortable level, and gradually increase the
                                intensity and duration of your workouts. If you
                                have any health concerns or specific fitness
                                goals, consulting with a healthcare professional
                                or fitness expert can help tailor a workout
                                routine to your individual needs.
                              </p>
                            </Col>
                            <Col md="1"></Col>
                          </>
                        ) : selectChartParameter1 === 'Increased' ? (
                          <>
                            <Col md="1"></Col>
                            <Col
                              md="5"
                              style={{
                                backgroundColor: 'rgb(164 230 124)',
                                borderRadius: '30px',
                                margin: '10px',
                              }}
                            >
                              <h3
                                style={{
                                  textAlign: 'center',
                                  padding: '10px',
                                  backgroundColor: 'rgb(125 190 241)',
                                  borderRadius: '30px',
                                  margin: '15px 50px 15px 50px',
                                }}
                              >
                                Diet
                              </h3>
                              <h4>Healthy Eating Habits</h4>
                              <p>
                                Emphasize a balanced diet with a variety of
                                nutrient-dense foods, including fruits,
                                vegetables, whole grains, lean proteins, and
                                healthy fats.
                              </p>
                              <h4>Portion Control</h4>
                              <p>
                                Be mindful of portion sizes to prevent
                                overeating and support weight management.
                              </p>
                              <h4>Regular Physical Activity</h4>
                              <p>
                                Incorporate regular exercise into your routine,
                                combining cardiovascular activities with
                                strength training.
                              </p>
                              <h4>Hydration</h4>
                              <p>
                                Stay well-hydrated with water, and limit the
                                intake of sugary beverages and excessive
                                calorie-laden drinks.
                              </p>
                              <h4>Behavioral Changes</h4>
                              <p>
                                Address emotional or stress-related eating
                                habits through mindfulness and behavioral
                                strategies.
                              </p>
                              <p>
                                For individuals in this BMI range, the goal may
                                be to prevent further weight gain, promote a
                                gradual and sustainable weight loss if needed,
                                and improve overall health. Consulting with
                                healthcare professionals or a registered
                                dietitian can provide personalized guidance and
                                support. Remember, small, sustainable changes
                                over time are key to achieving and maintaining a
                                healthy weight.
                              </p>
                            </Col>
                            <Col
                              md="5"
                              style={{
                                backgroundColor: 'rgb(125 190 241)',
                                borderRadius: '30px',
                                margin: '10px',
                              }}
                            >
                              <h3
                                style={{
                                  textAlign: 'center',
                                  padding: '10px',
                                  backgroundColor: 'rgb(164 230 124)',
                                  borderRadius: '30px',
                                  margin: '15px 50px 15px 50px',
                                }}
                              >
                                Exercises
                              </h3>
                              <h4>Running or Jogging</h4>
                              <p>
                                A great cardiovascular exercise that can be
                                adapted to different fitness levels. Start with
                                a jog and gradually increase intensity.
                              </p>
                              <h4>Interval Training</h4>
                              <p>
                                Incorporate high-intensity interval training
                                (HIIT) with activities like jumping jacks,
                                burpees, or sprints, followed by periods of rest
                                or lower-intensity exercise.
                              </p>
                              <h4>Bodyweight Strength Training</h4>
                              <p>
                                Include bodyweight exercises like squats,
                                lunges, push-ups, and planks for overall
                                strength development.
                              </p>
                              <h4>Cycling (Outdoor or Stationary)</h4>
                              <p>
                                Cycling is a low-impact cardiovascular exercise
                                that also targets the lower body muscles.
                              </p>
                              <h4>Yoga or Pilates</h4>
                              <p>
                                These exercises focus on flexibility, core
                                strength, and overall body awareness, promoting
                                balance in your fitness routine. Always start at
                                a comfortable level and gradually increase the
                                intensity and duration of your workouts. If you
                                have any health concerns or conditions, consult
                                with a healthcare professional or fitness expert
                                for personalized guidance.
                              </p>
                            </Col>
                            <Col md="1"></Col>
                          </>
                        ) : selectChartParameter1 === 'High' ? (
                          <>
                            <Col md="1"></Col>
                            <Col
                              md="5"
                              style={{
                                backgroundColor: 'rgb(164 230 124)',
                                borderRadius: '30px',
                                margin: '10px',
                              }}
                            >
                              <h3
                                style={{
                                  textAlign: 'center',
                                  padding: '10px',
                                  backgroundColor: 'rgb(125 190 241)',
                                  borderRadius: '30px',
                                  margin: '15px 50px 15px 50px',
                                }}
                              >
                                Diet
                              </h3>
                              <h4>Balanced and Nutrient-Dense Diet</h4>
                              <p>
                                Emphasize a balanced diet with a variety of
                                nutrient-dense foods, including fruits,
                                vegetables, whole grains, lean proteins, and
                                healthy fats.
                              </p>
                              <h4>Portion Control and Mindful Eating</h4>
                              <p>
                                Be mindful of portion sizes and practice mindful
                                eating to avoid overconsumption.
                              </p>
                              <h4>Regular Exercise</h4>
                              <p>
                                Engage in regular physical activity, combining
                                both cardiovascular exercises and strength
                                training to support weight management and
                                overall health.
                              </p>
                              <h4>Hydration</h4>
                              <p>
                                Stay well-hydrated with water and limit the
                                intake of sugary beverages.
                              </p>
                              <h4>Professional Guidance</h4>
                              <p>
                                Address emotional or stress-related eating
                                habits through mindfulness and behavioral
                                strategies.
                              </p>
                              <p>
                                Consult with healthcare professionals or a
                                registered dietitian for personalized advice and
                                support in developing a sustainable and
                                effective weight management plan. Individuals in
                                this BMI range may be at risk for
                                obesity-related health issues, and adopting a
                                healthy lifestyle becomes crucial. Making
                                gradual and sustainable changes to diet and
                                exercise, along with professional guidance, can
                                contribute to improved health outcomes.
                                Remember, the goal is long-term well-being
                                rather than rapid weight loss.
                              </p>
                            </Col>
                            <Col
                              md="5"
                              style={{
                                backgroundColor: 'rgb(125 190 241)',
                                borderRadius: '30px',
                                margin: '10px',
                              }}
                            >
                              <h3
                                style={{
                                  fontFamily: 'cursive',
                                  textAlign: 'center',
                                  padding: '10px',
                                  backgroundColor: 'rgb(164 230 124)',
                                  borderRadius: '30px',
                                  margin: '15px 50px 15px 50px',
                                }}
                              >
                                Exercises
                              </h3>
                              <h4>Brisk Walking</h4>
                              <p>
                                A simple yet effective cardiovascular exercise.
                                Start with a brisk walk and gradually increase
                                intensity and duration.
                              </p>
                              <h4>Swimming or Water Aerobics</h4>
                              <p>
                                These activities provide a full-body workout
                                with reduced impact on joints.
                              </p>
                              <h4>Cycling (Outdoor or Stationary)</h4>
                              <p>
                                Cycling is a low-impact cardiovascular exercise
                                that can be adapted to different fitness levels.
                              </p>
                              <h4>Bodyweight Exercises - Modified</h4>
                              <p>
                                Include modified versions of squats, lunges, and
                                push-ups, focusing on proper form to avoid
                                excessive stress on joints.
                              </p>
                              <h4>Resistance Band Workouts</h4>
                              <p>
                                Incorporate resistance bands for strength
                                training to target various muscle groups with
                                controlled resistance. Remember to start at a
                                comfortable intensity and gradually progress. If
                                you have any existing health concerns or
                                conditions, it's crucial to consult with a
                                healthcare professional or fitness expert before
                                beginning a new exercise routine. They can
                                provide guidance tailored to your individual
                                needs and help ensure a safe and effective
                                fitness plan.
                              </p>
                            </Col>
                            <Col md="1"></Col>
                          </>
                        ) : selectChartParameter1 === 'Very High' ? (
                          <>
                            <Col md="1"></Col>
                            <Col
                              md="5"
                              style={{
                                backgroundColor: 'rgb(164 230 124)',
                                borderRadius: '30px',
                                margin: '10px',
                              }}
                            >
                              <h3
                                style={{
                                  textAlign: 'center',
                                  padding: '10px',
                                  backgroundColor: 'rgb(125 190 241)',
                                  borderRadius: '30px',
                                  margin: '15px 50px 15px 50px',
                                }}
                              >
                                Diet
                              </h3>
                              <h4>Medical Assessment</h4>
                              <p>
                                Seek a comprehensive medical assessment to
                                identify any underlying health conditions and
                                determine the most appropriate weight management
                                approach.
                              </p>
                              <h4>Balanced and Nutrient-Dense Diet</h4>
                              <p>
                                Emphasize a balanced diet with a variety of
                                nutrient-dense foods to support overall health
                                and address specific nutritional needs.
                              </p>
                              <h4>Portion Control and Mindful Eating</h4>
                              <p>
                                Practice portion control and mindful eating to
                                avoid overeating and promote a healthy
                                relationship with food.
                              </p>
                              <h4>Regular Exercise</h4>
                              <p>
                                Engage in regular physical activity,
                                incorporating both cardiovascular exercises and
                                strength training under the guidance of
                                healthcare professionals.
                              </p>
                              <h4>Multidisciplinary Approach</h4>
                              <p>
                                Address emotional or stress-related eating
                                habits through mindfulness and behavioral
                                strategies.
                              </p>
                              <p>
                                Consider a multidisciplinary approach involving
                                healthcare professionals, including a registered
                                dietitian, physical therapist, and possibly a
                                behavioral therapist, to address various aspects
                                of health and well-being. Individuals with a BMI
                                above 35 may face increased risks of
                                obesity-related health issues, and a holistic
                                approach to weight management is crucial.
                                Professional guidance, ongoing support, and a
                                focus on sustainable lifestyle changes can
                                contribute to improved health outcomes. It's
                                essential to work closely with healthcare
                                professionals to create a personalized plan that
                                aligns with individual health needs and goals.
                              </p>
                            </Col>
                            <Col
                              md="5"
                              style={{
                                backgroundColor: 'rgb(125 190 241)',
                                borderRadius: '30px',
                                margin: '10px',
                              }}
                            >
                              <h3
                                style={{
                                  textAlign: 'center',
                                  padding: '10px',
                                  backgroundColor: 'rgb(164 230 124)',
                                  borderRadius: '30px',
                                  margin: '15px 50px 15px 50px',
                                }}
                              >
                                Exercises
                              </h3>
                              <h4>Stationary Cycling</h4>
                              <p>
                                Provides a low-impact cardiovascular workout,
                                supporting weight loss without putting excessive
                                stress on the joints.
                              </p>
                              <h4>Aquatic Exercises</h4>
                              <p>
                                Water aerobics or swimming in a pool reduces
                                impact on joints while providing a full-body
                                workout.
                              </p>
                              <h4>Seated Leg Press</h4>
                              <p>
                                Using resistance machines for seated leg presses
                                helps strengthen leg muscles without bearing
                                full body weight.
                              </p>
                              <h4>Bodyweight Chair Squats</h4>
                              <p>
                                Performing squats using a sturdy chair for
                                support can help strengthen lower body muscles
                                with reduced impact.
                              </p>
                              <h4>Seated Resistance Band Rows</h4>
                              <p>
                                Seated rows with resistance bands provide upper
                                body strength training while minimizing strain
                                on joints. Always consult with a healthcare
                                professional or fitness expert before starting a
                                new exercise routine, especially with a BMI
                                above 35. They can provide personalized
                                recommendations based on your health status and
                                fitness level. Additionally, consider working
                                with a certified trainer who has experience with
                                individuals with higher BMIs for proper guidance
                                and support.
                              </p>
                            </Col>
                            <Col md="1"></Col>
                          </>
                        ) : null}
                      </Row>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setShowPatientDetail1(false);
                      }}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                {/* {
                                        showObesity && speciality.value === 'Obesity' ? (
                                            <div className="row Tabs">
                                            <div className="col-md-12">
                                            <div className="tabsec" style={{display:'flex',justifyContent:'center'}}>
                                                <div className="tablink">
                                                    <div className="genderContainer">
                                                        <p className="gen-para text-center">BMI (%) <i onClick={() => {
                                                            setBmiScoreModal(true);
                                                        }} className="fas fa-info-circle"></i></p>
                                                        <div id="healthpiechartbs" style={{ height: "400px" }}>
                                                            <HighchartsReact
                                                                highcharts={Highcharts}
                                                                options={bmi}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                             </div>
                                            </div>
                                            </div>
                                     
                                        ):(
                                            <></>
                                        )
                                    } */}

                {speciality.value === 'Obesity' &&
                  selectChartValue1 === 'BMI' ? (
                  <div
                    className="col-md-12 bgcolorshadow1"
                    style={{ overflowX: 'auto' }}
                    id="tablescroll"
                  >
                    <div
                      className="titletable"
                      style={{ backgroundColor: '#0D92D4' }}
                    >
                      {selectChartValue1 !== '' ? (
                        <h4 style={{ textTransform: 'uppercase' }}>
                          {selectChartValue1} - {selectChartParameter1}
                        </h4>
                      ) : (
                        <h4>PATIENT DETAILS</h4>
                      )}
                    </div>
                    {speciality.value === 'Obesity' &&
                      selectChartValue1 === 'BMI' ? (
                      <div>
                        {selectChartParameter1 === 'Underweight'
                          ? tableData1(underWeightBmi, 'Obesity')
                          : selectChartParameter1 === 'Normal'
                            ? tableData1(normalBmi, 'Obesity')
                            : selectChartParameter1 === 'Increased'
                              ? tableData1(increasedBmi, 'Obesity')
                              : selectChartParameter1 === 'High'
                                ? tableData1(highBmi, 'Obesity')
                                : selectChartParameter1 === 'Very High'
                                  ? tableData1(veryhighBmi, 'Obesity')
                                  : null}
                      </div>
                    ) : null}
                    {speciality.value === 'Obesity' &&
                      selectChartValue1 === 'BMI' &&
                      multiFilterShow
                      ? tableData1(multiFilterData, 'Obesity')
                      : null}
                  </div>
                ) : null}

                {speciality.value === 'Sickle Cell' &&
                  selectChartValue1 === 'Sickle Cell' ? (
                  <div
                    className="col-md-12 bgcolorshadow1"
                    style={{ overflowX: 'auto' }}
                    id="tablescroll"
                  >
                    <div
                      className="titletable"
                      style={{ backgroundColor: '#0D92D4' }}
                    >
                      {selectChartValue1 !== '' ? (
                        <h4 style={{ textTransform: 'uppercase' }}>
                          {selectChartValue1} - {selectChartParameter1}
                        </h4>
                      ) : (
                        <h4>PATIENT DETAILS</h4>
                      )}
                    </div>
                    {speciality.value === 'Sickle Cell' &&
                      selectChartValue1 === 'Sickle Cell' ? (
                      <div>
                        {selectChartParameter1 === 'Positve'
                          ? tableData1(positiveSolibility, 'Sickle Cell')
                          : selectChartParameter1 === 'Negative'
                            ? tableData1(negativeSolibility, 'Sickle Cell')
                            : selectChartParameter1 === 'Absent'
                              ? tableData1(hbAA, 'Sickle Cell')
                              : selectChartParameter1 === 'HbAS Trait'
                                ? tableData1(hbAS, 'Sickle Cell')
                                : selectChartParameter1 === 'Anemia'
                                  ? tableData1(hbSS, 'Sickle Cell')
                                  : selectChartParameter1 === 'HbAC Trait'
                                    ? tableData1(hbAC, 'Sickle Cell')
                                    : selectChartParameter1 === 'HbSC Trait'
                                      ? tableData1(hbSC, 'Sickle Cell')
                                      : selectChartParameter1 === 'HbCC Trait'
                                        ? tableData1(hbCC, 'Sickle Cell')
                                        : selectChartParameter1 === 'Optimal'
                                          ? tableData1(optimalHealthScore, 'Non-Invasive')
                                          : selectChartParameter1 === 'Good'
                                            ? tableData1(goodHealthScore, 'Non-Invasive')
                                            : selectChartParameter1 === 'Fair'
                                              ? tableData1(averageHealthScore, 'Non-Invasive')
                                              : selectChartParameter1 === 'Poor'
                                                ? tableData1(poorHealthScore, 'Non-Invasive')
                                                : null}
                      </div>
                    ) : null}
                    {speciality.value === 'Sickle Cell' &&
                      selectChartValue1 === 'Sickle Cell' &&
                      multiFilterShow
                      ? tableData1(multiFilterData, 'Sickle Cell')
                      : null}
                  </div>
                ) : null}
                {speciality.value === 'Sickle Cell' &&
                  selectChartValue1 === 'Non-Invasive' ? (
                  <div
                    className="col-md-12 bgcolorshadow1"
                    style={{ overflowX: 'auto' }}
                    id="tablescroll"
                  >
                    <div
                      className="titletable"
                      style={{ backgroundColor: '#0D92D4' }}
                    >
                      {selectChartValue1 !== '' ? (
                        <h4 style={{ textTransform: 'uppercase' }}>
                          {selectChartValue1} - {selectChartParameter1}
                        </h4>
                      ) : (
                        <h4>PATIENT DETAILS</h4>
                      )}
                    </div>
                    {speciality.value === 'Sickle Cell' &&
                      selectChartValue1 === 'Non-Invasive' ? (
                      <div>
                        {selectChartParameter1 === 'Optimal'
                          ? tableData1(optimalHealthScore, 'Non-Invasive')
                          : selectChartParameter1 === 'Good'
                            ? tableData1(goodHealthScore, 'Non-Invasive')
                            : selectChartParameter1 === 'Fair'
                              ? tableData1(averageHealthScore, 'Non-Invasive')
                              : selectChartParameter1 === 'Poor'
                                ? tableData1(poorHealthScore, 'Non-Invasive')
                                : null}
                      </div>
                    ) : null}
                    {speciality.value === 'Sickle Cell' &&
                      selectChartValue1 === 'Non-Invasive' &&
                      multiFilterShow
                      ? tableData1(multiFilterData, 'Non-Invasive')
                      : null}
                  </div>
                ) : null}
                {speciality.value === 'Sickle Cell' &&
                  selectChartValue1 === 'Hemoglobin' ? (
                  <div
                    className="col-md-12 bgcolorshadow1"
                    style={{ overflowX: 'auto' }}
                    id="tablescroll"
                  >
                    <div
                      className="titletable"
                      style={{ backgroundColor: '#0D92D4' }}
                    >
                      {selectChartValue1 !== '' ? (
                        <h4 style={{ textTransform: 'uppercase' }}>
                          {selectChartValue1} - {selectChartParameter1}
                        </h4>
                      ) : (
                        <h4>PATIENT DETAILS</h4>
                      )}
                    </div>
                    {speciality.value === 'Sickle Cell' &&
                      selectChartValue1 === 'Hemoglobin' ? (
                      <div>
                        {selectChartParameter1 === 'Low'
                          ? tableData1(lowHemoglobin, 'Hemoglobin')
                          : selectChartParameter1 === 'Normal'
                            ? tableData1(normalHemoglobin, 'Hemoglobin')
                            : selectChartParameter1 === 'High'
                              ? tableData1(highHemoglobin, 'Hemoglobin')
                              : null}
                      </div>
                    ) : null}
                    {speciality.value === 'Sickle Cell' &&
                      selectChartValue1 === 'Hemoglobin' &&
                      multiFilterShow
                      ? tableData1(multiFilterData, 'Hemoglobin')
                      : null}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default Dashboard;
